var _feBlend, _feBlend2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesAddon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2475 1650",
    style: {
      enableBackground: "new 0 0 2475 1650"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 2475,
    height: 1650
  })), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.6589,
    y1: 796.6494,
    x2: 2338.6272,
    y2: 796.6494
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M255.444,1156.006c-11.197,38.025-15.588,77.923-12.856,117.374 c7.686,110.978,134.46,188.346,242.914,188.346c0.048,0,1326.867,0,1326.867,0c49.69,0,94.222-29.587,113.319-74.657 c0.099-0.234,0.199-0.467,0.299-0.7c30.663-71.07,108.349-64.3,166.515-70.717c62.906-6.941,128.814-41.408,177.517-87.118 c32.376-30.386,58.532-71.61,66.419-118.766c9.262-55.374-11.177-117.915-55.456-145.612 c-61.532-38.476-54.979-17.197-81.725-105.673c-45.897-151.832,142.034-419.863,63.017-563.664 c-102.737-186.963-568.005-179.968-743.693-140.786c-182.847,40.78-337.325,213.073-523.322,241.757 c-76.333,11.772-157.627,4.246-227.67-34.654c-93.474-51.913-168.443-130.409-278.246-125.767 C331.79,242.03,152.18,326.166,154.685,499.798c1.809,125.41,36.624,250.247,100.265,359.525 c10.927,18.762,22.747,37.197,30.533,57.371c29.072,75.323,0.72,151.165-24.417,221.981 C259.033,1144.403,257.159,1150.182,255.444,1156.006z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1844.448,1456.692c0,0,155.294-516.977,423.032-789.487 c17.998-18.319,48.096-9.331,53.004,15.908C2353.302,851.882,2403.722,1361.246,1844.448,1456.692z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE5FE"
    },
    d: "M1897.148,1425.579c-1.32,1.184,0.182,3.244,1.641,2.25 c53.771-36.637,264.447-219.446,363.448-600.465c0.318-1.224-1.408-1.786-1.827-0.593 C2229.562,914.681,2105.872,1238.317,1897.148,1425.579z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M103.356,831.407c-2.773-1.883-1.102-6.214,2.211-5.709 c52.896,8.059,244.664,49.188,381.888,233.83c125.553,168.939,185.965,308.032,206.349,360.682 c4.031,10.411-4.633,21.317-15.684,19.73c-65.499-9.405-247.524-45.335-319.317-160.501 C273.009,1141.812,235.699,921.281,103.356,831.407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE5FE"
    },
    d: "M255.425,930.471c0,0,170.181,72.797,424.468,490.757 C679.893,1421.228,402.087,1014.722,255.425,930.471z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M767.448,1187.378c0,0-100.136-628.75-387.568-987.373 c-19.322-24.107-58.983-17.975-69.861,10.895C237.282,403.94,79.145,993.67,767.448,1187.378z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE5FE"
    },
    d: "M706.692,1143.196c1.446,1.582-0.832,3.776-2.489,2.398 c-61.082-50.815-293.12-295.935-347.415-757.072c-0.174-1.481,2.109-1.888,2.417-0.428 C381.839,495.659,477.944,893.141,706.692,1143.196z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066502868561777071010000006795331255507261059_",
    gradientUnits: "userSpaceOnUse",
    x1: 1218.9117,
    y1: -17.7211,
    x2: 1266.9155,
    y2: 1392.4216
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066502868561777071010000006795331255507261059_)"
    },
    d: "M2069.561,1408.41 c0,16.245-13.304,29.536-29.565,29.536H441.251c-16.26,0-29.565-13.291-29.565-29.536l-13.303-918.755 c0-16.245,19.139-47.959,54.216-45.576l1562.47-40.429c20.402-0.528,40.129,7.325,54.577,21.726 c14.448,14.401,22.353,34.09,21.871,54.474L2069.561,1408.41z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026122995615323322960000012990667728488110514_",
    gradientUnits: "userSpaceOnUse",
    x1: 1213.8882,
    y1: 1659.9199,
    x2: 1285.2672,
    y2: -257.0877
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026122995615323322960000012990667728488110514_)"
    },
    d: "M2040.373,1380.073 c0,15.383-12.587,27.97-27.971,27.97H479.806c-15.384,0-27.97-12.587-27.97-27.97l-12.554-834.054 c1.479-50.191,45.482-68.23,72.157-67.165l1497.486-40.175c14.333-0.385,28.192,5.138,38.344,15.264 c10.152,10.126,15.734,23.984,15.375,38.318L2040.373,1380.073z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.67
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M468.398,981.998c-1.232,0-2.24-0.991-2.259-2.226l-0.993-67.641 c-0.018-1.247,0.979-2.275,2.226-2.293c1.175-0.04,2.274,0.98,2.293,2.227l0.993,67.641c0.018,1.247-0.979,2.275-2.227,2.293 C468.421,981.998,468.41,981.998,468.398,981.998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M465.964,816.244c-1.232,0-2.24-0.991-2.258-2.226l-3.804-259.063 c0.078-17.302,5.408-31.123,15.843-41.121c18.981-18.187,48.686-17.274,49.944-17.227l478.214-12.834 c1.251,0.022,2.286,0.951,2.319,2.2c0.034,1.247-0.95,2.284-2.198,2.319l-478.344,12.834 c-1.341-0.055-29.194-0.905-46.809,15.972c-9.516,9.118-14.378,21.848-14.45,37.836l3.804,259.018 c0.018,1.247-0.979,2.275-2.227,2.293C465.987,816.244,465.976,816.244,465.964,816.244z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.37,
      fill: "#FFFFFF"
    },
    d: "M519.356,1333.804c1.604-68.935,1.007-679.377-2.948-732.097 c-3.955-52.721,78.153-62.609,204.215-68.542c126.061-5.933,1189.693-29.423,1217.08-31.643 c61.558-4.991,74.299,87.019,68.141,286.767c-4.627,150.068-12.295,397.281-15.824,510.967 c-1.051,33.851-28.719,60.709-62.585,60.802c-255.954,0.703-1236.948,3.515-1302.253,5.46 C550.029,1367.755,518.72,1361.139,519.356,1333.804z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067919376279112004830000017173504074379050677_",
    gradientUnits: "userSpaceOnUse",
    x1: 1237.3717,
    y1: 610.5885,
    x2: 1258.3746,
    y2: 1510.6884
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067919376279112004830000017173504074379050677_)"
    },
    d: "M2191.753,1484.839H321.906 c-4.128,0-7.505-3.377-7.505-7.505v-65.715c0-4.128,3.377-7.505,7.505-7.505h1869.847c4.128,0,7.505,3.377,7.505,7.505v65.715 C2199.258,1481.462,2195.881,1484.839,2191.753,1484.839z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114772931006087156260000011398215089931883157_",
    gradientUnits: "userSpaceOnUse",
    x1: 2389.1663,
    y1: 561.7683,
    x2: 1912.6866,
    y2: 941.4634
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114772931006087156260000011398215089931883157_)"
    },
    d: "M1919.888,944.301 c6.239,4.834,177.509-7.574,249.46,7.316c0,0,55.772-243.334-104.362-252.892c-160.134-9.558-215.656,89.262-215.656,89.262 L1919.888,944.301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1750.754,687.259l314.232,11.466c0,0-114.504,1.569-101.825,146.385 c12.678,144.816,77.202,567.684-86.667,568.098s-166.491-74.43-166.491-74.43L1750.754,687.259z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156549903920048927940000008530408691721288066_",
    gradientUnits: "userSpaceOnUse",
    x1: 2253.3628,
    y1: 604.0502,
    x2: 1660.2455,
    y2: 1080.53
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000156549903920048927940000008530408691721288066_)"
    },
    d: "M1604.003,619.312l121.463-28.276 c0,0,81.212-7.3,92.195,64.883c10.983,72.183,7.8,499.83,4.363,588.026c-3.437,88.196,4.835,156.028,54.469,169.264 l-361.079,6.248L1604.003,619.312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1950.185,1008.865c-1.956,0-3.597-1.525-3.713-3.5c-0.058-0.982-5.979-99.02-16.591-180.609 c-11.012-84.658,35.316-102.51,37.293-103.229c1.941-0.7,4.072,0.296,4.772,2.23c0.7,1.927-0.291,4.055-2.213,4.762l0,0 c-1.747,0.654-42.663,16.897-32.47,95.278c10.646,81.852,16.581,180.142,16.64,181.123c0.124,2.053-1.442,3.817-3.492,3.938 C1950.333,1008.863,1950.258,1008.865,1950.185,1008.865z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1567.053,1335.319c0,0,22.828-320.124,185.215-515.264c2.117-2.544,5.785-1.906,6.905,1.224 C1776.865,870.711,1876.32,1188.603,1567.053,1335.319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE5FE"
    },
    d: "M1745.258,912.952c-1.368,18.678-4.072,37.106-7.205,55.501 c-3.24,18.367-7.046,36.643-11.526,54.762c-8.935,36.24-20.118,71.976-33.868,106.751 c-6.932,17.359-14.283,34.569-22.512,51.372c-3.989,8.459-8.44,16.697-12.706,25.017c-4.532,8.186-8.957,16.428-13.865,24.399 c-19.007,32.216-41.271,62.574-66.684,89.895c-0.758,0.814-2.032,0.86-2.847,0.103c-0.767-0.713-0.852-1.884-0.228-2.698 l0.02-0.026c22.614-29.313,42.988-60.126,60.66-92.473c4.554-8.006,8.607-16.289,12.944-24.409 c4.03-8.285,8.242-16.475,11.997-24.891c1.883-4.204,3.926-8.331,5.75-12.562l5.563-12.649c1.824-4.23,3.536-8.509,5.31-12.76 c1.794-4.244,3.47-8.536,5.124-12.837c3.436-8.552,6.626-17.201,9.846-25.84c3.073-8.694,6.144-17.388,9.017-26.154 c5.926-17.472,11.188-35.167,16.268-52.922c4.974-17.783,9.601-35.68,13.755-53.695c4.234-17.987,7.996-36.151,11.186-54.321 l0.01-0.057c0.192-1.095,1.236-1.828,2.331-1.635C1744.624,911.001,1745.33,911.937,1745.258,912.952z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1568.924,1378.734c0,0,142.625-294.895,323.697-314.914c3.213-0.355,5.914,2.391,5.521,5.6 C1893.575,1106.755,1856.081,1303.365,1568.924,1378.734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE5FE"
    },
    d: "M1858.039,1111.637c-10,12.49-20.366,24.572-30.897,36.554 c-5.329,5.927-10.661,11.854-16.055,17.722c-5.453,5.813-10.831,11.699-16.347,17.453 c-22.001,23.078-44.813,45.384-68.346,66.901c-11.66,10.878-23.82,21.201-35.789,31.734l-18.38,15.308 c-3.069,2.544-6.115,5.116-9.226,7.61l-9.419,7.372c-24.84,20.016-51.021,38.297-77.437,56.136 c-0.922,0.622-2.172,0.38-2.794-0.541c-0.613-0.908-0.386-2.137,0.502-2.767l0.05-0.035l19.442-13.774l9.718-6.884 c3.206-2.342,6.341-4.781,9.514-7.167l19.03-14.326c6.259-4.885,12.424-9.892,18.64-14.831l9.306-7.432l9.135-7.643 l18.254-15.303c11.887-10.532,23.964-20.849,35.544-31.724c11.766-10.669,23.222-21.672,34.688-32.662l16.943-16.751 l16.693-17.001c5.559-5.673,10.979-11.479,16.476-17.213c5.438-5.788,10.813-11.635,16.188-17.483 c10.692-11.733,21.298-23.602,31.424-35.769l0.026-0.031c0.711-0.854,1.98-0.97,2.834-0.26 C1858.599,1109.534,1858.722,1110.783,1858.039,1111.637z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1357.072,625.184c0,0,221.168,12.153,368.394-34.148c0,0-97.874-6.706-97.874,219.265 c0,172.768,25.623,502.529,3.251,565.127c-22.371,62.598-106.024,146.745-225.94,74.428 C1284.988,1377.538,1357.072,625.184,1357.072,625.184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1598.866,1119.152c-2.021,0-3.681-1.621-3.72-3.652c-0.002-0.114-0.228-11.841-1.355-52.028 c-0.058-2.055,1.561-3.769,3.616-3.824c2.007-0.102,3.769,1.561,3.824,3.616c1.129,40.237,1.357,51.982,1.36,52.096 c0.039,2.055-1.597,3.754-3.652,3.793C1598.914,1119.152,1598.89,1119.152,1598.866,1119.152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1596.161,1021.057c-2.005,0-3.657-1.592-3.718-3.609c-0.8-26.159-2.048-55.077-3.369-85.695 c-1.781-41.367-3.628-84.144-4.602-125.351c-2.569-108.752,15.37-150.5,30.871-166.371c8.424-8.628,15.484-8.877,16.262-8.877 c2.055,0,3.723,1.667,3.723,3.722c0,2.031-1.626,3.681-3.647,3.723c-0.848,0.061-43.614,4.76-39.763,167.629 c0.972,41.134,2.814,83.873,4.597,125.206c1.321,30.641,2.569,59.582,3.369,85.787c0.063,2.055-1.551,3.771-3.606,3.834 C1596.239,1021.057,1596.2,1021.057,1596.161,1021.057z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128470477900066213310000009353016872914035846_",
    gradientUnits: "userSpaceOnUse",
    x1: 1558.2295,
    y1: 532.5477,
    x2: 1116.4924,
    y2: -385.671
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000128470477900066213310000009353016872914035846_)"
    },
    d: "M1298.272,286.401 c0,0,244.023,26.599,275.457-14.762c0,0-25.007-74.44-99.267-69.487C1400.202,207.105,1298.272,286.401,1298.272,286.401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M504.628,370.151c21.279,239.139,65.974,744.959,85.418,991.355 c4.335,54.93,48.363,98.318,103.352,101.848c195.877,12.573,636.698,36.967,805.863,14.27h0 c-38.752-19.104-63.154-58.698-62.803-101.902l8.982-1105.655c0.318-39.068,39.231-67.141,75.816-53.432 c23.048,8.637,40.502,27.037,52.473,55.003c-15.972-46.543-41.09-80.595-99.267-69.487c0,0-568.993,5.688-845.1,22.808 C554.336,229.612,497.965,295.276,504.628,370.151z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 526.361,
    y: 227.175,
    width: 919.51,
    height: 1243.129
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 526.361,
    y: 227.175,
    width: 919.51,
    height: 1243.129,
    id: "SVGID_00000015331330027729432010000015321038189085077376_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000106136253484918074710000007401568726086366101_",
    filterUnits: "userSpaceOnUse",
    x: 526.361,
    y: 227.175,
    width: 919.51,
    height: 1243.129
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 526.361,
    y: 227.175,
    width: 919.51,
    height: 1243.129,
    id: "SVGID_00000015331330027729432010000015321038189085077376_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000106136253484918074710000007401568726086366101_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110431755107397025470000008983091601013767808_",
    gradientUnits: "userSpaceOnUse",
    x1: 1331.7974,
    y1: 461.6414,
    x2: 154.5005,
    y2: 1968.2198
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000015331330027729432010000015321038189085077376_)",
      fill: "url(#SVGID_00000110431755107397025470000008983091601013767808_)"
    },
    d: " M645.383,256.609l764.556-29.434c-31.534,233.454-18.226,708.864-6.193,1177.393c0.713,27.776,17.003,52.775,42.125,64.646 l0,0c0,0-509.954,5.876-729.068-9.665c-51.592-3.659-93.679-42.698-101.344-93.849 c-30.081-200.736-102.049-719.311-87.071-993.854C531.818,308.977,582.466,259.031,645.383,256.609z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M645.383,256.609l764.556-29.434c-31.534,233.454-18.226,708.864-6.193,1177.393 c0.713,27.776,17.003,52.775,42.125,64.646l0,0c0,0-509.954,5.876-729.068-9.665c-51.592-3.659-93.679-42.698-101.344-93.849 c-30.081-200.736-102.049-719.311-87.071-993.854C531.818,308.977,582.466,259.031,645.383,256.609z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040554336000860364990000014483586052914735803_",
    gradientUnits: "userSpaceOnUse",
    x1: 641.9785,
    y1: 574.6295,
    x2: 1312.8374,
    y2: 574.6295
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000040554336000860364990000014483586052914735803_)"
    },
    d: "M664.51,563.284 c107.492-2.58,520.124-12.937,624.32-15.554c13.143-0.33,24.007,7.807,24.007,17.959l0,0c0,9.664-9.901,17.597-22.409,17.955 L666.51,601.526c-12.018,0.344-22.397-6.437-23.943-15.645l-0.391-2.329C640.407,573.023,650.765,563.613,664.51,563.284z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022523068852158777880000008720781033844218298_",
    gradientUnits: "userSpaceOnUse",
    x1: 654.2769,
    y1: 657.7741,
    x2: 1104.5748,
    y2: 657.7741
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000022523068852158777880000008720781033844218298_)"
    },
    d: "M657.759,676.183L657.759,676.183 c1.825,2.363,5.154,3.786,8.717,3.726l428.416-7.185c5.382-0.09,9.683-3.484,9.683-7.64v-21.805 c0-4.333-4.661-7.798-10.268-7.637l-416.469,12.022C659.288,648.2,648.252,663.875,657.759,676.183z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116958304489044189230000004307272467934227895_",
    gradientUnits: "userSpaceOnUse",
    x1: 641.9785,
    y1: 812.3105,
    x2: 1312.8374,
    y2: 812.3105
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116958304489044189230000004307272467934227895_)"
    },
    d: "M664.51,800.964 c107.492-2.58,520.124-12.937,624.32-15.554c13.143-0.33,24.007,7.806,24.007,17.958v0c0,9.664-9.901,17.596-22.409,17.955 L666.51,839.207c-12.018,0.345-22.397-6.437-23.943-15.645l-0.391-2.33C640.407,810.704,650.765,801.294,664.51,800.964z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115502997760789571290000012750005135183672245_",
    gradientUnits: "userSpaceOnUse",
    x1: 654.2769,
    y1: 895.455,
    x2: 1104.5748,
    y2: 895.455
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000115502997760789571290000012750005135183672245_)"
    },
    d: "M657.759,913.865L657.759,913.865 c1.825,2.363,5.154,3.786,8.717,3.726l428.416-7.185c5.382-0.09,9.683-3.484,9.683-7.64v-21.806 c0-4.332-4.661-7.798-10.268-7.637l-416.469,12.022C659.288,885.88,648.252,901.556,657.759,913.865z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168807927198217138240000015338915185956027535_",
    gradientUnits: "userSpaceOnUse",
    x1: 641.9785,
    y1: 1049.9915,
    x2: 1312.8374,
    y2: 1049.9915
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168807927198217138240000015338915185956027535_)"
    },
    d: "M664.51,1038.645 c107.492-2.58,520.124-12.937,624.32-15.554c13.143-0.33,24.007,7.806,24.007,17.959l0,0c0,9.664-9.901,17.596-22.409,17.955 l-623.918,17.883c-12.018,0.344-22.397-6.437-23.943-15.645l-0.391-2.33C640.407,1048.385,650.765,1038.975,664.51,1038.645z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134968115268280621120000008217607430180454568_",
    gradientUnits: "userSpaceOnUse",
    x1: 654.2769,
    y1: 1133.136,
    x2: 1104.5748,
    y2: 1133.136
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134968115268280621120000008217607430180454568_)"
    },
    d: "M657.759,1151.546L657.759,1151.546 c1.825,2.363,5.154,3.786,8.717,3.726l428.416-7.186c5.382-0.09,9.683-3.484,9.683-7.64v-21.806 c0-4.333-4.661-7.798-10.268-7.637l-416.469,12.022C659.288,1123.561,648.252,1139.237,657.759,1151.546z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M641.32,369.371l24.694-1.091c10.063-0.445,17.475,1.184,22.24,4.888 c4.762,3.703,7.332,9.814,7.708,18.332c0.248,5.606-0.759,10.349-3.019,14.23c-2.261,3.881-5.471,6.311-9.628,7.291 l0.029,0.662c5.533,1.127,9.596,3.513,12.19,7.156c2.593,3.645,4.028,8.578,4.303,14.801 c0.388,8.784-1.658,15.761-6.139,20.935c-4.481,5.173-10.805,7.94-18.969,8.301l-29.13,1.287L641.32,369.371z M659.989,407.551 l8.276-0.366c3.796-0.168,6.421-1.3,7.876-3.399c1.455-2.098,2.094-5.155,1.916-9.172c-0.177-4.016-1.188-6.856-3.03-8.523 c-1.843-1.665-4.662-2.414-8.457-2.246l-7.614,0.336L659.989,407.551z M660.653,422.579l1.196,27.078l9.071-0.401 c3.75-0.166,6.492-1.436,8.223-3.813c1.73-2.376,2.489-5.97,2.277-10.781c-0.382-8.65-4.37-12.809-11.961-12.473 L660.653,422.579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M717.563,462.983l-4.278-96.792l16.949-0.749l4.278,96.792L717.563,462.983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M754.968,461.33l-4.278-96.792l18.007-0.796l3.581,81.035l24.96-1.103l0.697,15.757 L754.968,461.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M809.455,458.922l-4.278-96.792l18.008-0.796l3.581,81.035l24.96-1.103l0.697,15.757 L809.455,458.922z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M961.899,403.562c0.708,16.022-1.749,28.469-7.371,37.34 c-5.623,8.872-14.017,13.555-25.182,14.049c-11.211,0.495-20.008-3.416-26.389-11.737c-6.383-8.318-9.93-20.556-10.643-36.71 c-0.708-16.021,1.749-28.435,7.375-37.241c5.625-8.806,14.086-13.458,25.386-13.958c11.166-0.493,19.918,3.421,26.257,11.742 C957.669,375.369,961.192,387.54,961.899,403.562z M910.723,405.823c0.488,11.034,2.25,19.382,5.286,25.039 c3.036,5.66,7.246,8.37,12.632,8.132c10.857-0.48,15.787-12.018,14.788-34.617c-0.999-22.597-6.884-33.659-17.652-33.183 c-5.474,0.242-9.472,3.304-11.998,9.187C911.252,386.264,910.233,394.745,910.723,405.823z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M996.021,450.677l-17.876,0.79l-4.278-96.792l43.365-1.917l0.688,15.558l-25.489,1.127 l1.188,26.879l23.767-1.051l0.688,15.558l-23.767,1.051L996.021,450.677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1110.039,418.905c0.4,9.048-1.579,16.079-5.933,21.092c-4.356,5.012-10.837,7.709-19.443,8.089 c-8.431,0.373-15.677-0.965-21.736-4.014l-0.787-17.81c7.447,4.404,14.193,6.47,20.241,6.203 c3.442-0.153,5.993-1.214,7.653-3.19c1.659-1.975,2.417-4.595,2.273-7.862c-0.142-3.221-1.31-6.122-3.502-8.701 c-2.193-2.578-5.744-5.395-10.656-8.451c-4.275-2.685-7.542-5.294-9.799-7.825c-2.257-2.532-4.042-5.404-5.356-8.619 c-1.315-3.214-2.067-6.984-2.258-11.31c-0.366-8.298,1.649-14.975,6.047-20.035c4.398-5.059,10.48-7.76,18.249-8.103 c7.415-0.328,14.634,1.432,21.66,5.278l-5.32,14.696c-2.174-1.141-4.44-2.147-6.8-3.016c-2.36-0.867-4.864-1.244-7.513-1.127 c-2.913,0.128-5.111,1.188-6.592,3.176c-1.482,1.99-2.15,4.64-2.004,7.95c0.145,3.267,1.208,6.072,3.191,8.416 c1.983,2.346,5.382,4.959,10.197,7.842c6.499,3.957,11.093,8.09,13.781,12.393 C1108.319,408.28,1109.789,413.256,1110.039,418.905z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1168.949,443.035l-6.641-24.184l-25.224,1.115l-4.482,24.676l-18.007,0.796l19.671-98.249 l24.43-1.08l28.328,96.128L1168.949,443.035z M1158.227,403.045l-6.158-22.282c-0.37-1.354-1.217-4.755-2.541-10.202 c-1.324-5.447-2.138-9.093-2.44-10.937c-0.405,3.822-0.949,8.035-1.63,12.642c-0.681,4.608-2.515,15.136-5.503,31.586 L1158.227,403.045z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1195.564,441.858l-4.278-96.792l18.007-0.796l3.582,81.035l24.959-1.103l0.697,15.757 L1195.564,441.858z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1293.68,437.523l-43.629,1.928l-4.278-96.792l43.629-1.928l0.688,15.558l-25.622,1.132 l1.018,23.04l23.768-1.05l0.69,15.624l-23.768,1.05l1.185,26.813l25.622-1.132L1293.68,437.523z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108278833668825324180000015189199214803286707_",
    gradientUnits: "userSpaceOnUse",
    x1: -693.3336,
    y1: 915.3455,
    x2: -555.0058,
    y2: 915.3455,
    gradientTransform: "matrix(1 0 0 1 1694.4741 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108278833668825324180000015189199214803286707_)"
    },
    d: "M1047.67,919.809 c0,0-7.169-18.872-15.543-17.144c-8.374,1.729-17.535,8.161-17.535,8.161l-13.452,18.193c0,0,37.764,14.877,51.045,6.351 c0,0,38.573,6.665,87.283-1.328c-7.051-14.887-11.254-29.791-13.722-41.36C1101.075,906.648,1074.502,917.079,1047.67,919.809z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147922383505222886670000016361866021389061291_",
    gradientUnits: "userSpaceOnUse",
    x1: 1281.6475,
    y1: 220.0159,
    x2: 1233.6427,
    y2: 571.051
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147922383505222886670000016361866021389061291_)"
    },
    d: "M1251.994,782.924 c0,0-55.226,69.558-126.247,109.76c2.468,11.569,6.671,26.473,13.722,41.36c36.843-6.046,79.482-20.473,115.631-52.533 L1251.994,782.924z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025409230332635738880000011076963272224267914_",
    gradientUnits: "userSpaceOnUse",
    x1: 1439.9882,
    y1: 241.6695,
    x2: 1391.9833,
    y2: 592.7059
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025409230332635738880000011076963272224267914_)"
    },
    d: "M1320.868,1091.225 c-10.8-51.301-21.6-81.001-57.764-178.24c-11.381-30.6-21.715-61.561-16.72-93.825l5.61-36.236c0,0,70.279-23.781,148.182-1.002 c0,0,106.285,46.172,34.093,274.202C1401.729,1092.53,1363.647,1102.906,1320.868,1091.225z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181791744038757699340000008863696749336090039_",
    gradientUnits: "userSpaceOnUse",
    x1: 1306.4708,
    y1: 772.4863,
    x2: 1343.4709,
    y2: 985.4864
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181791744038757699340000008863696749336090039_)"
    },
    d: "M1263.957,736.676l18.224,43.781 c1.151,2.765,3.639,4.735,6.591,5.242c10.507,1.802,35.918,4.617,52.607-6.357c1.989-1.308,2.495-4.011,1.134-5.964 l-33.668-48.336L1263.957,736.676z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145748195340610607310000003546324564358938274_",
    gradientUnits: "userSpaceOnUse",
    x1: 854.4634,
    y1: 695.3264,
    x2: 934.1887,
    y2: 729.9896,
    gradientTransform: "matrix(1 0 0 1 404.3718 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145748195340610607310000003546324564358938274_)"
    },
    d: "M1282.804,669.693 c-0.765,0.72-32.301,62.648-32.301,62.648l35.742,17.254l38.609-54.253C1324.854,695.341,1295.616,657.632,1282.804,669.693z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181053450089165719330000002162450086276063616_",
    gradientUnits: "userSpaceOnUse",
    x1: 4711.2617,
    y1: 5294.1118,
    x2: 4806.499,
    y2: 5294.1118,
    gradientTransform: "matrix(-0.6854 -0.7281 -0.7281 0.6854 8400.2246 544.7815)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181053450089165719330000002162450086276063616_)"
    },
    d: "M1308.612,701.851l-17.827,29.716 c-0.271,0.451-0.593,0.859-0.978,1.217c-2.122,1.975-9.382,7.72-14.996-0.102c-4.784-6.667-9.272-12.727-14.082-15.227 c-2.809-1.459-6.265-0.294-7.691,2.532c-2.937,5.821-8.626,17.688-12.2,28.94c-0.896,2.82,0.56,5.848,3.302,6.959 c7.238,2.932,21.542,8.235,34.235,9.987c2.085,0.288,4.149-0.592,5.39-2.292c5.461-7.481,20.853-28.388,26.106-33.621 c4.88-4.862,13.888-3.029,17.946-1.863c1.541,0.443,3.181,0.23,4.554-0.597c4.118-2.481,11.304-8.657,4.73-19.115 c-1.634-2.6-0.801-6.063,1.765-7.751c4.598-3.025,9.587-8.701,4.833-17.895c-4.812-9.306-13.404-10.142-19.257-9.426 c-2.589,0.316-5.218-1.042-6.212-3.454c-0.442-1.073-1.315-1.987-2.942-2.317c-3.067-0.622-5.081-3.427-4.478-6.499 c1.032-5.266,0.255-12.107-8.154-16.73c-15.422-8.479-28.93,5.337-32.365,16.999c-3.435,11.663,13.808,19.905,24.654,21.281 c7.967,1.011,12.335,9.706,14.093,14.251C1309.678,698.493,1309.521,700.334,1308.612,701.851z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168115617433650323350000005315891051222740137_",
    gradientUnits: "userSpaceOnUse",
    x1: 849.4953,
    y1: 706.7529,
    x2: 929.2206,
    y2: 741.4161,
    gradientTransform: "matrix(1 0 0 1 404.3718 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168115617433650323350000005315891051222740137_)"
    },
    d: "M1302.363,738.856 c0,0,7.671-18.049,16.449-17.312c8.778,0.736,15.687,9.481,4.808,19.311C1310.088,753.083,1302.363,738.856,1302.363,738.856z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122694614901836522510000003307214675091283594_",
    gradientUnits: "userSpaceOnUse",
    x1: 1311.151,
    y1: 1548.137,
    x2: 1410.2323,
    y2: 1548.137
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122694614901836522510000003307214675091283594_)"
    },
    d: "M1313.949,1543.345 c16.974,1.467,46.433,3.85,69.657,4.873c13.96,0.614,21.998-0.753,26.626-2.605c-0.008,0.521-0.022,1.015-0.043,1.472 c-0.11,2.444-2.096,4.399-4.564,4.537c-43.883,2.449-78.783,0.848-91.208,0.092c-2.569-0.157-4.1-2.948-2.787-5.139 C1312.289,1545.479,1313.084,1544.406,1313.949,1543.345z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102540171062255758600000012288740522737566882_",
    gradientUnits: "userSpaceOnUse",
    x1: 1245.0132,
    y1: 1455.4371,
    x2: 886.2488,
    y2: 1557.6935,
    gradientTransform: "matrix(1 0 0 1 404.3718 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102540171062255758600000012288740522737566882_)"
    },
    d: "M1383.606,1548.217 c-23.224-1.022-52.683-3.405-69.657-4.873c16.688-20.474,69.657-34.274,69.657-34.274h14.96 c10.289,14.832,11.779,28.953,11.666,36.541C1405.604,1547.465,1397.566,1548.832,1383.606,1548.217z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144312076445561785710000000538033353082301117_",
    gradientUnits: "userSpaceOnUse",
    x1: 2521.0454,
    y1: 1501.6074,
    x2: 2548.9548,
    y2: 1501.6074,
    gradientTransform: "matrix(-1 0 0 1 3922.1304 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000144312076445561785710000000538033353082301117_)"
    },
    d: "M1401.085,1484.648l-1.4,27.703 c-0.151,3-2.398,5.521-5.402,5.95c-2.989,0.428-6.993,0.482-11.238-0.931c-2.612-0.869-4.551-3.07-5.033-5.755l-4.837-26.968 H1401.085z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163037318783153347490000003594694008008233636_",
    gradientUnits: "userSpaceOnUse",
    x1: 1569.7899,
    y1: 1546.0002,
    x2: 1607.7593,
    y2: 1546.0002
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163037318783153347490000003594694008008233636_)"
    },
    d: "M1595.396,1548.009 c7.361-1.026,10.691-4.85,12.087-8.938c0.009,0.037,0.019,0.074,0.028,0.11c1.083,4.312-1.428,8.781-6.447,10.907 c-6.067,2.569-12.699,3.007-17.85,2.795c-5.524-0.228-10.596-2.514-13.383-6.173l-0.042-0.055 C1575.335,1549.399,1583.12,1549.722,1595.396,1548.009z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078008385733640075160000010700574722980077749_",
    gradientUnits: "userSpaceOnUse",
    x1: 1045.0079,
    y1: 1434.6536,
    x2: 1268.5854,
    y2: 1580.239,
    gradientTransform: "matrix(1 0 0 1 404.3718 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078008385733640075160000010700574722980077749_)"
    },
    d: "M1560.69,1484.47h12.337 c18.792-0.384,30.593,39.252,34.455,54.601c-1.396,4.088-4.727,7.912-12.087,8.938c-12.276,1.713-20.06,1.389-25.606-1.355 c-10.152-13.36-15.186-32.926-17.605-44.346C1549.432,1489.321,1560.69,1484.47,1560.69,1484.47z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060024192281831879680000000779428427293477786_",
    gradientUnits: "userSpaceOnUse",
    x1: 2343.6157,
    y1: 1478.3413,
    x2: 2376.97,
    y2: 1478.3413,
    gradientTransform: "matrix(-1 0 0 1 3922.1304 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060024192281831879680000000779428427293477786_)"
    },
    d: "M1571.442,1458.757l6.851,27.247 c0.84,3.341-0.759,6.796-3.848,8.381c-3.832,1.967-9.228,4.033-14.187,3.435c-2.332-0.281-4.269-1.924-5.04-4.12 l-10.057-28.667L1571.442,1458.757z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021801937552054679910000000115429826961196171_",
    gradientUnits: "userSpaceOnUse",
    x1: 1450.4966,
    y1: 1398.9417,
    x2: 1454.4968,
    y2: 1707.9418
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021801937552054679910000000115429826961196171_)"
    },
    d: "M1579.613,1466.633 c-8.523,7.561-36.247,8.558-36.247,8.558c-99.864-239.683-141.498-305.665-141.498-305.665 c14.419,90.467,3.108,322.683,3.108,322.683c-16.479,7.272-37.726,0-37.726,0c-1.338-148.107-22.191-307.254-49.084-409.084 c67.496-1.517,104.177-16.231,115.897-25.5C1490.328,1148.33,1579.613,1466.633,1579.613,1466.633z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124879296729105761070000016702553700326801043_",
    gradientUnits: "userSpaceOnUse",
    x1: 1414.9753,
    y1: 1091.2601,
    x2: 1445.9752,
    y2: 1390.2601
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5304,
    style: {
      stopColor: "#FE7164"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7214,
    style: {
      stopColor: "#FE776B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8575,
    style: {
      stopColor: "#FE8076"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9668,
    style: {
      stopColor: "#FF8D87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124879296729105761070000016702553700326801043_)"
    },
    d: "M1301.164,1150.104l12.42,77.247 c2.166,13.47,14.643,22.813,28.249,21.153l185.885-22.674c9.094-1.109,15.99-8.702,16.172-17.82 c0.398-19.96-0.386-55.482-8.763-87.845L1301.164,1150.104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1343.9,1243.509c-0.181,0-0.333-0.142-0.342-0.325c-0.01-0.189,0.135-0.351,0.324-0.362 c0.545-0.029,1.093-0.077,1.642-0.144l1.068-0.13c0.187-0.021,0.359,0.111,0.382,0.3c0.023,0.188-0.111,0.36-0.299,0.383 l-1.068,0.13c-0.565,0.069-1.128,0.118-1.688,0.148C1343.912,1243.509,1343.906,1243.509,1343.9,1243.509z M1337.529,1243.012 c-0.024,0-0.048-0.002-0.072-0.008c-0.904-0.193-1.807-0.44-2.685-0.734c-0.18-0.06-0.276-0.255-0.216-0.435 c0.06-0.18,0.253-0.277,0.435-0.216c0.853,0.286,1.731,0.526,2.609,0.714c0.186,0.04,0.304,0.222,0.264,0.407 C1337.83,1242.901,1337.688,1243.012,1337.529,1243.012z M1352.997,1242.456c-0.171,0-0.319-0.128-0.34-0.302 c-0.023-0.188,0.111-0.359,0.299-0.382l2.728-0.333c0.188-0.022,0.36,0.111,0.382,0.3c0.023,0.188-0.111,0.359-0.299,0.382 l-2.728,0.333C1353.025,1242.455,1353.011,1242.456,1352.997,1242.456z M1362.089,1241.347c-0.171,0-0.319-0.128-0.34-0.302 c-0.023-0.188,0.111-0.36,0.299-0.382l2.728-0.333c0.19-0.022,0.36,0.112,0.382,0.3c0.023,0.188-0.111,0.36-0.299,0.382 l-2.728,0.333C1362.117,1241.346,1362.103,1241.347,1362.089,1241.347z M1371.181,1240.238c-0.171,0-0.319-0.128-0.34-0.302 c-0.023-0.188,0.111-0.359,0.299-0.382l2.728-0.333c0.186-0.025,0.36,0.111,0.382,0.299c0.023,0.188-0.111,0.359-0.299,0.383 l-2.728,0.333C1371.209,1240.237,1371.195,1240.238,1371.181,1240.238z M1329.141,1239.474c-0.065,0-0.131-0.019-0.19-0.058 c-0.771-0.513-1.52-1.075-2.227-1.671c-0.145-0.122-0.163-0.339-0.042-0.484c0.123-0.145,0.339-0.163,0.484-0.041 c0.687,0.579,1.416,1.126,2.165,1.625c0.158,0.105,0.201,0.318,0.095,0.476 C1329.361,1239.421,1329.252,1239.474,1329.141,1239.474z M1380.273,1239.129c-0.171,0-0.319-0.128-0.34-0.302 c-0.023-0.188,0.111-0.36,0.299-0.383l2.728-0.333c0.187-0.023,0.359,0.111,0.382,0.3c0.023,0.188-0.111,0.359-0.299,0.382 l-2.728,0.333C1380.301,1239.128,1380.287,1239.129,1380.273,1239.129z M1389.365,1238.02c-0.171,0-0.319-0.128-0.34-0.302 c-0.023-0.188,0.111-0.359,0.299-0.383l2.728-0.333c0.188-0.021,0.36,0.111,0.382,0.299c0.023,0.188-0.111,0.359-0.299,0.382 l-2.728,0.333C1389.393,1238.019,1389.379,1238.02,1389.365,1238.02z M1398.457,1236.911c-0.171,0-0.319-0.128-0.34-0.302 c-0.023-0.188,0.111-0.359,0.299-0.383l2.728-0.332c0.189-0.025,0.36,0.111,0.382,0.299c0.023,0.188-0.111,0.36-0.299,0.382 l-2.728,0.333C1398.485,1236.91,1398.471,1236.911,1398.457,1236.911z M1407.549,1235.802c-0.171,0-0.319-0.128-0.34-0.302 c-0.023-0.188,0.111-0.359,0.299-0.383l2.728-0.333c0.185-0.02,0.36,0.111,0.382,0.3c0.023,0.188-0.111,0.359-0.299,0.383 l-2.728,0.333C1407.576,1235.801,1407.563,1235.802,1407.549,1235.802z M1416.64,1234.693c-0.171,0-0.319-0.128-0.34-0.302 c-0.023-0.188,0.111-0.359,0.299-0.383l2.728-0.333c0.187-0.022,0.359,0.111,0.382,0.299c0.023,0.188-0.111,0.359-0.299,0.382 l-2.728,0.333C1416.668,1234.693,1416.654,1234.693,1416.64,1234.693z M1425.732,1233.584c-0.171,0-0.319-0.128-0.34-0.302 c-0.023-0.188,0.111-0.359,0.299-0.382l2.728-0.333c0.188-0.026,0.36,0.111,0.382,0.299c0.023,0.188-0.111,0.359-0.299,0.383 l-2.728,0.333C1425.76,1233.583,1425.746,1233.584,1425.732,1233.584z M1322.644,1233.099c-0.109,0-0.216-0.052-0.283-0.148 c-0.528-0.762-1.016-1.562-1.452-2.378c-0.089-0.167-0.026-0.375,0.141-0.465c0.167-0.09,0.376-0.026,0.465,0.141 c0.424,0.793,0.899,1.57,1.411,2.311c0.108,0.156,0.069,0.37-0.087,0.478 C1322.78,1233.079,1322.712,1233.099,1322.644,1233.099z M1434.824,1232.475c-0.171,0-0.319-0.128-0.34-0.302 c-0.023-0.188,0.111-0.359,0.299-0.382l2.728-0.333c0.189-0.025,0.36,0.111,0.382,0.299c0.023,0.188-0.111,0.359-0.299,0.383 l-2.728,0.333C1434.852,1232.474,1434.839,1232.475,1434.824,1232.475z M1443.916,1231.366c-0.171,0-0.319-0.128-0.34-0.302 c-0.023-0.188,0.111-0.359,0.299-0.383l2.728-0.333c0.185-0.022,0.36,0.111,0.382,0.3c0.023,0.188-0.111,0.359-0.299,0.382 l-2.728,0.333C1443.944,1231.365,1443.93,1231.366,1443.916,1231.366z M1453.008,1230.257c-0.171,0-0.319-0.128-0.34-0.302 c-0.023-0.188,0.111-0.359,0.299-0.383l2.728-0.333c0.186-0.021,0.359,0.111,0.382,0.3c0.023,0.188-0.111,0.359-0.299,0.382 l-2.728,0.333C1453.036,1230.256,1453.022,1230.257,1453.008,1230.257z M1462.1,1229.148c-0.171,0-0.319-0.128-0.34-0.302 c-0.023-0.188,0.111-0.359,0.299-0.382l2.728-0.333c0.19-0.027,0.36,0.111,0.382,0.299c0.023,0.188-0.111,0.359-0.299,0.382 l-2.728,0.333C1462.128,1229.147,1462.114,1229.148,1462.1,1229.148z M1471.192,1228.039c-0.171,0-0.319-0.128-0.34-0.302 c-0.023-0.188,0.111-0.359,0.299-0.383l2.728-0.333c0.189-0.02,0.36,0.111,0.382,0.3c0.023,0.188-0.111,0.359-0.299,0.383 l-2.728,0.333C1471.219,1228.038,1471.206,1228.039,1471.192,1228.039z M1480.283,1226.93c-0.171,0-0.319-0.128-0.34-0.302 c-0.023-0.188,0.111-0.36,0.299-0.383l2.728-0.333c0.193-0.024,0.36,0.111,0.382,0.3c0.023,0.188-0.111,0.359-0.299,0.383 l-2.728,0.332C1480.311,1226.929,1480.297,1226.93,1480.283,1226.93z M1489.376,1225.821c-0.171,0-0.319-0.128-0.34-0.302 c-0.023-0.188,0.111-0.359,0.299-0.382l2.728-0.333c0.186-0.026,0.359,0.111,0.382,0.299c0.023,0.188-0.111,0.359-0.299,0.382 l-2.727,0.333C1489.403,1225.82,1489.39,1225.821,1489.376,1225.821z M1318.979,1224.766c-0.156,0-0.298-0.108-0.334-0.267 c-0.117-0.512-0.217-1.031-0.302-1.556l-0.188-1.169c-0.03-0.187,0.098-0.364,0.285-0.394c0.188-0.03,0.363,0.097,0.393,0.285 l0.189,1.169c0.082,0.51,0.18,1.015,0.293,1.513c0.042,0.185-0.074,0.369-0.259,0.411 C1319.031,1224.764,1319.005,1224.766,1318.979,1224.766z M1498.468,1224.712c-0.171,0-0.319-0.128-0.34-0.302 c-0.023-0.188,0.111-0.359,0.299-0.383l2.728-0.332c0.189-0.025,0.36,0.111,0.382,0.299c0.023,0.188-0.111,0.36-0.299,0.382 l-2.728,0.333C1498.495,1224.711,1498.482,1224.712,1498.468,1224.712z M1507.559,1223.603c-0.171,0-0.319-0.128-0.34-0.302 c-0.023-0.188,0.111-0.359,0.299-0.383l2.728-0.333c0.188-0.022,0.36,0.111,0.382,0.299c0.023,0.188-0.111,0.359-0.299,0.382 l-2.728,0.333C1507.587,1223.602,1507.573,1223.603,1507.559,1223.603z M1516.651,1222.494c-0.171,0-0.319-0.128-0.34-0.302 c-0.023-0.188,0.111-0.36,0.299-0.382l2.728-0.333c0.192-0.021,0.36,0.111,0.382,0.3c0.023,0.188-0.111,0.36-0.299,0.382 l-2.728,0.333C1516.679,1222.493,1516.665,1222.494,1516.651,1222.494z M1525.686,1221.083c-0.146,0-0.281-0.093-0.327-0.239 c-0.058-0.181,0.042-0.374,0.223-0.432c0.855-0.272,1.694-0.614,2.492-1.015c0.17-0.085,0.376-0.017,0.462,0.153 c0.085,0.169,0.017,0.376-0.153,0.461c-0.831,0.418-1.703,0.773-2.593,1.056 C1525.756,1221.078,1525.72,1221.083,1525.686,1221.083z M1533.311,1216.198c-0.083,0-0.166-0.03-0.231-0.09 c-0.14-0.128-0.15-0.345-0.022-0.485c0.605-0.662,1.161-1.376,1.653-2.123c0.104-0.158,0.316-0.203,0.476-0.098 c0.158,0.104,0.202,0.317,0.098,0.476c-0.511,0.776-1.09,1.52-1.719,2.208 C1533.497,1216.161,1533.404,1216.198,1533.311,1216.198z M1317.476,1215.733c-0.166,0-0.312-0.12-0.338-0.289l-0.437-2.713 c-0.03-0.187,0.098-0.364,0.285-0.394c0.188-0.03,0.363,0.097,0.394,0.285l0.436,2.713c0.03,0.187-0.098,0.363-0.285,0.394 C1317.512,1215.731,1317.494,1215.733,1317.476,1215.733z M1537.469,1208.158c-0.024,0-0.049-0.002-0.073-0.008 c-0.186-0.04-0.303-0.223-0.263-0.409c0.189-0.872,0.31-1.769,0.359-2.665c0.01-0.19,0.155-0.331,0.362-0.324 c0.189,0.01,0.335,0.172,0.324,0.362c-0.051,0.933-0.176,1.866-0.373,2.773 C1537.769,1208.048,1537.627,1208.158,1537.469,1208.158z M1316.022,1206.689c-0.166,0-0.312-0.12-0.339-0.289l-0.436-2.713 c-0.03-0.187,0.098-0.364,0.285-0.394c0.188-0.03,0.363,0.097,0.394,0.285l0.436,2.713c0.03,0.187-0.098,0.364-0.285,0.394 C1316.058,1206.688,1316.04,1206.689,1316.022,1206.689z M1537.929,1199.028c0,0-0.001,0-0.002,0 c-0.189-0.001-0.342-0.156-0.341-0.345c0.003-0.662,0.005-1.336,0.005-2.022l0-0.724c0-0.19,0.153-0.344,0.343-0.344h0 c0.189,0,0.343,0.153,0.343,0.343l0,0.725c0,0.687-0.002,1.363-0.005,2.025 C1538.271,1198.876,1538.118,1199.028,1537.929,1199.028z M1314.568,1197.647c-0.166,0-0.312-0.12-0.338-0.289l-0.437-2.713 c-0.03-0.187,0.097-0.364,0.284-0.394c0.188-0.03,0.364,0.097,0.394,0.284l0.436,2.713c0.03,0.187-0.097,0.364-0.284,0.394 C1314.605,1197.645,1314.586,1197.647,1314.568,1197.647z M1537.87,1189.866c-0.187,0-0.34-0.15-0.343-0.337 c-0.016-0.901-0.036-1.817-0.059-2.746c-0.005-0.19,0.145-0.347,0.335-0.352c0.203-0.014,0.347,0.145,0.352,0.335 c0.023,0.93,0.042,1.848,0.059,2.75c0.003,0.19-0.148,0.346-0.337,0.35C1537.874,1189.866,1537.872,1189.866,1537.87,1189.866z  M1313.114,1188.603c-0.166,0-0.312-0.12-0.339-0.289l-0.436-2.713c-0.03-0.187,0.097-0.364,0.284-0.394 c0.188-0.03,0.363,0.097,0.394,0.285l0.436,2.713c0.03,0.187-0.098,0.363-0.285,0.394 C1313.151,1188.602,1313.132,1188.603,1313.114,1188.603z M1537.6,1180.708c-0.183,0-0.335-0.145-0.343-0.329 c-0.037-0.905-0.078-1.82-0.122-2.743c-0.009-0.19,0.137-0.351,0.327-0.36c0.201-0.012,0.351,0.137,0.36,0.327 c0.044,0.925,0.085,1.842,0.123,2.748c0.008,0.19-0.14,0.35-0.329,0.357C1537.61,1180.708,1537.605,1180.708,1537.6,1180.708z  M1311.66,1179.56c-0.166,0-0.312-0.12-0.339-0.289l-0.436-2.713c-0.03-0.187,0.098-0.364,0.285-0.394 c0.188-0.03,0.364,0.097,0.394,0.285l0.437,2.713c0.03,0.187-0.098,0.364-0.285,0.394 C1311.697,1179.559,1311.678,1179.56,1311.66,1179.56z M1537.112,1171.56c-0.179,0-0.331-0.139-0.342-0.321 c-0.06-0.906-0.123-1.82-0.191-2.739c-0.014-0.189,0.128-0.354,0.317-0.368c0.186-0.018,0.354,0.128,0.368,0.317 c0.068,0.921,0.131,1.836,0.191,2.745c0.012,0.189-0.131,0.353-0.32,0.365C1537.127,1171.559,1537.12,1171.56,1537.112,1171.56 z M1310.206,1170.517c-0.166,0-0.312-0.12-0.338-0.289l-0.437-2.713c-0.03-0.187,0.098-0.364,0.285-0.394 c0.188-0.03,0.363,0.097,0.394,0.285l0.436,2.713c0.03,0.188-0.097,0.364-0.284,0.394 C1310.243,1170.516,1310.224,1170.517,1310.206,1170.517z M1536.392,1162.426c-0.175,0-0.325-0.134-0.341-0.312 c-0.083-0.907-0.171-1.818-0.263-2.733c-0.019-0.189,0.119-0.357,0.308-0.376c0.186-0.021,0.357,0.118,0.376,0.307 c0.092,0.917,0.18,1.83,0.263,2.739c0.018,0.189-0.122,0.356-0.311,0.374 C1536.414,1162.426,1536.403,1162.426,1536.392,1162.426z M1308.752,1161.474c-0.166,0-0.312-0.12-0.339-0.289l-0.436-2.713 c-0.03-0.187,0.098-0.364,0.285-0.394c0.188-0.031,0.363,0.097,0.394,0.285l0.436,2.713c0.03,0.187-0.098,0.363-0.285,0.394 C1308.789,1161.473,1308.77,1161.474,1308.752,1161.474z M1535.423,1153.317c-0.171,0-0.319-0.128-0.34-0.302 c-0.11-0.906-0.224-1.814-0.343-2.724c-0.024-0.188,0.108-0.361,0.296-0.385c0.188-0.025,0.36,0.108,0.385,0.296 c0.119,0.912,0.233,1.823,0.343,2.73c0.023,0.188-0.111,0.359-0.299,0.382 C1535.45,1153.316,1535.436,1153.317,1535.423,1153.317z M1307.298,1152.431c-0.166,0-0.312-0.12-0.338-0.289l-0.493-3.063 l1.011-0.129c0.187-0.022,0.36,0.109,0.384,0.297c0.024,0.188-0.109,0.36-0.297,0.384l-0.307,0.039l0.38,2.363 c0.03,0.187-0.098,0.363-0.285,0.394C1307.335,1152.429,1307.316,1152.431,1307.298,1152.431z M1313.88,1148.82 c-0.17,0-0.318-0.126-0.34-0.3c-0.024-0.188,0.109-0.36,0.297-0.384l2.726-0.349c0.188-0.026,0.36,0.109,0.384,0.297 c0.024,0.188-0.109,0.36-0.297,0.384l-2.726,0.349C1313.909,1148.819,1313.895,1148.82,1313.88,1148.82z M1322.966,1147.657 c-0.171,0-0.318-0.126-0.34-0.3c-0.024-0.188,0.109-0.36,0.297-0.384l2.726-0.349c0.183-0.026,0.36,0.109,0.384,0.297 c0.024,0.188-0.109,0.36-0.297,0.384l-2.726,0.349C1322.995,1147.656,1322.98,1147.657,1322.966,1147.657z M1332.051,1146.495 c-0.17,0-0.318-0.126-0.34-0.3c-0.024-0.188,0.109-0.36,0.297-0.385l2.726-0.349c0.184-0.023,0.36,0.109,0.384,0.297 c0.024,0.188-0.109,0.36-0.297,0.385l-2.725,0.349C1332.08,1146.494,1332.065,1146.495,1332.051,1146.495z M1341.136,1145.332 c-0.17,0-0.318-0.126-0.34-0.3c-0.024-0.188,0.109-0.36,0.297-0.384l2.726-0.349c0.185-0.02,0.36,0.109,0.384,0.297 c0.024,0.188-0.109,0.36-0.297,0.385l-2.726,0.348C1341.165,1145.331,1341.151,1145.332,1341.136,1145.332z M1534.18,1144.244 c-0.167,0-0.313-0.122-0.339-0.292c-0.138-0.901-0.281-1.804-0.429-2.707c-0.031-0.187,0.096-0.364,0.283-0.394 c0.191-0.031,0.364,0.096,0.395,0.283c0.148,0.905,0.292,1.81,0.43,2.714c0.029,0.188-0.1,0.363-0.288,0.392 C1534.215,1144.242,1534.198,1144.244,1534.18,1144.244z M1350.221,1144.17c-0.17,0-0.318-0.126-0.34-0.3 c-0.024-0.188,0.109-0.36,0.297-0.385l2.725-0.348c0.187-0.024,0.36,0.109,0.384,0.297c0.024,0.188-0.109,0.36-0.297,0.384 l-2.726,0.349C1350.25,1144.169,1350.236,1144.17,1350.221,1144.17z M1359.306,1143.007c-0.17,0-0.318-0.126-0.34-0.3 c-0.024-0.188,0.109-0.36,0.297-0.385l2.726-0.348c0.188-0.024,0.36,0.109,0.384,0.297c0.024,0.188-0.109,0.36-0.297,0.384 l-2.726,0.349C1359.336,1143.006,1359.321,1143.007,1359.306,1143.007z M1368.391,1141.845c-0.17,0-0.318-0.126-0.34-0.3 c-0.024-0.188,0.109-0.36,0.297-0.385l2.726-0.349c0.183-0.021,0.36,0.109,0.384,0.297c0.024,0.188-0.109,0.36-0.297,0.385 l-2.726,0.349C1368.421,1141.844,1368.406,1141.845,1368.391,1141.845z M1377.477,1140.682c-0.17,0-0.318-0.126-0.34-0.3 c-0.024-0.188,0.109-0.36,0.297-0.384l2.726-0.349c0.184-0.024,0.36,0.109,0.384,0.297c0.024,0.188-0.109,0.36-0.297,0.384 l-2.726,0.349C1377.506,1140.681,1377.491,1140.682,1377.477,1140.682z M1386.562,1139.519c-0.17,0-0.318-0.126-0.34-0.3 c-0.024-0.188,0.109-0.36,0.297-0.384l2.726-0.349c0.185-0.024,0.36,0.109,0.384,0.297c0.024,0.188-0.109,0.36-0.297,0.384 l-2.726,0.349C1386.591,1139.518,1386.576,1139.519,1386.562,1139.519z M1395.647,1138.357c-0.17,0-0.318-0.126-0.34-0.3 c-0.024-0.188,0.109-0.36,0.297-0.385l2.726-0.348c0.186-0.025,0.36,0.109,0.384,0.297c0.024,0.188-0.109,0.36-0.297,0.384 l-2.726,0.349C1395.677,1138.356,1395.662,1138.357,1395.647,1138.357z M1404.732,1137.194c-0.171,0-0.318-0.126-0.34-0.3 c-0.024-0.188,0.109-0.36,0.297-0.384l2.726-0.349c0.188-0.022,0.36,0.109,0.384,0.297c0.024,0.188-0.109,0.36-0.297,0.385 l-2.726,0.348C1404.761,1137.193,1404.747,1137.194,1404.732,1137.194z M1413.818,1136.032c-0.17,0-0.318-0.126-0.34-0.3 c-0.024-0.188,0.109-0.36,0.297-0.384l2.726-0.349c0.188-0.025,0.36,0.109,0.384,0.297c0.024,0.188-0.109,0.36-0.297,0.384 l-2.726,0.349C1413.847,1136.031,1413.832,1136.032,1413.818,1136.032z M1532.635,1135.22c-0.162,0-0.306-0.115-0.337-0.279 c-0.171-0.898-0.346-1.796-0.527-2.692c-0.037-0.186,0.083-0.367,0.269-0.405c0.188-0.039,0.367,0.083,0.405,0.269 c0.181,0.899,0.358,1.799,0.528,2.7c0.036,0.187-0.087,0.366-0.273,0.402C1532.678,1135.218,1532.657,1135.22,1532.635,1135.22 z M1422.903,1134.869c-0.17,0-0.318-0.126-0.34-0.3c-0.024-0.188,0.109-0.36,0.297-0.384l2.726-0.349 c0.184-0.025,0.36,0.108,0.384,0.297c0.024,0.188-0.109,0.36-0.297,0.384l-2.726,0.349 C1422.932,1134.868,1422.917,1134.869,1422.903,1134.869z M1431.988,1133.707c-0.17,0-0.318-0.126-0.34-0.3 c-0.024-0.188,0.109-0.36,0.297-0.385l2.726-0.349c0.185-0.022,0.36,0.109,0.384,0.297s-0.109,0.36-0.297,0.385l-2.725,0.349 C1432.017,1133.706,1432.003,1133.707,1431.988,1133.707z M1441.073,1132.544c-0.17,0-0.318-0.126-0.34-0.3 c-0.024-0.188,0.109-0.36,0.297-0.384l2.726-0.349c0.186-0.023,0.36,0.109,0.384,0.297c0.024,0.188-0.109,0.36-0.297,0.385 l-2.726,0.348C1441.102,1132.543,1441.088,1132.544,1441.073,1132.544z M1450.158,1131.381c-0.17,0-0.318-0.126-0.34-0.3 c-0.024-0.188,0.109-0.36,0.297-0.384l2.725-0.349c0.187-0.023,0.36,0.109,0.384,0.297c0.024,0.188-0.109,0.36-0.297,0.384 l-2.726,0.349C1450.188,1131.38,1450.173,1131.381,1450.158,1131.381z M1459.243,1130.219c-0.17,0-0.318-0.126-0.34-0.3 c-0.024-0.188,0.109-0.36,0.297-0.384l2.726-0.349c0.188-0.023,0.36,0.109,0.384,0.297c0.024,0.188-0.109,0.36-0.297,0.384 l-2.726,0.349C1459.273,1130.218,1459.258,1130.219,1459.243,1130.219z M1468.329,1129.057c-0.17,0-0.318-0.126-0.34-0.3 c-0.024-0.188,0.109-0.36,0.297-0.385l2.726-0.349c0.183-0.023,0.36,0.109,0.384,0.297c0.024,0.188-0.109,0.36-0.297,0.385 l-2.726,0.349C1468.358,1129.056,1468.344,1129.057,1468.329,1129.057z M1477.414,1127.894c-0.17,0-0.318-0.126-0.34-0.3 c-0.024-0.188,0.109-0.36,0.297-0.384l2.726-0.349c0.185-0.02,0.36,0.109,0.384,0.297c0.024,0.188-0.109,0.36-0.297,0.384 l-2.726,0.349C1477.443,1127.893,1477.428,1127.894,1477.414,1127.894z M1486.499,1126.731c-0.17,0-0.318-0.126-0.34-0.3 c-0.024-0.188,0.109-0.36,0.297-0.384l2.726-0.349c0.186-0.024,0.36,0.109,0.384,0.297c0.024,0.188-0.109,0.36-0.297,0.384 l-2.726,0.349C1486.528,1126.73,1486.514,1126.731,1486.499,1126.731z M1530.75,1126.255c-0.156,0-0.297-0.107-0.334-0.266 c-0.207-0.892-0.419-1.782-0.638-2.67c-0.045-0.184,0.068-0.37,0.252-0.415c0.182-0.046,0.37,0.067,0.416,0.251 c0.219,0.891,0.433,1.784,0.64,2.679c0.043,0.185-0.072,0.37-0.257,0.412 C1530.802,1126.252,1530.776,1126.255,1530.75,1126.255z M1495.584,1125.569c-0.17,0-0.318-0.126-0.34-0.3 c-0.024-0.188,0.109-0.36,0.297-0.385l2.726-0.348c0.187-0.024,0.36,0.109,0.384,0.297c0.024,0.188-0.109,0.36-0.297,0.384 l-2.726,0.349C1495.614,1125.568,1495.599,1125.569,1495.584,1125.569z M1504.67,1124.406c-0.171,0-0.318-0.127-0.34-0.3 c-0.024-0.188,0.109-0.36,0.297-0.384l2.726-0.349c0.188-0.021,0.36,0.109,0.384,0.297c0.024,0.188-0.109,0.36-0.297,0.385 l-2.726,0.348C1504.699,1124.405,1504.684,1124.406,1504.67,1124.406z M1513.755,1123.244c-0.17,0-0.318-0.126-0.34-0.3 c-0.024-0.188,0.109-0.36,0.297-0.384l2.726-0.349c0.183-0.021,0.36,0.109,0.384,0.297c0.024,0.188-0.109,0.36-0.297,0.384 l-2.725,0.349C1513.784,1123.243,1513.769,1123.244,1513.755,1123.244z M1522.84,1122.081c-0.17,0-0.318-0.126-0.34-0.3 c-0.024-0.188,0.109-0.36,0.297-0.384l2.725-0.349c0.185-0.025,0.36,0.109,0.384,0.297c0.024,0.188-0.109,0.36-0.297,0.384 l-2.725,0.349C1522.869,1122.08,1522.855,1122.081,1522.84,1122.081z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116952291844282875760000004264772144666276761_",
    gradientUnits: "userSpaceOnUse",
    x1: -1381.6748,
    y1: 1312.3118,
    x2: -1377.0078,
    y2: 1470.3217,
    gradientTransform: "matrix(0.9919 -0.127 0.127 0.9919 2520.1729 -696.4259)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116952291844282875760000004264772144666276761_)"
    },
    d: "M1348.394,1086.829l-0.207-6.054 c0.448-1.509,1.628-2.688,3.144-3.132c5.669-1.662,19.813-5.117,27.384-0.837l1.922,6.819L1348.394,1086.829z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016060281306432401550000001170630543752471194_",
    gradientUnits: "userSpaceOnUse",
    x1: -1381.0905,
    y1: 1312.3011,
    x2: -1376.4237,
    y2: 1470.3065,
    gradientTransform: "matrix(0.9919 -0.127 0.127 0.9919 2520.1729 -696.4259)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016060281306432401550000001170630543752471194_)"
    },
    d: "M1365.734,1078.76 c-1.291,0.496-2.626,0.665-4.005,0.508c-1.669-0.19-2.995-1.492-3.207-3.151l-2.397-18.732l9.533-1.22l2.395,18.718 C1368.266,1076.549,1367.309,1078.155,1365.734,1078.76z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004547523380210874390000007617262184342191782_",
    gradientUnits: "userSpaceOnUse",
    x1: -1288.6721,
    y1: 1309.5659,
    x2: -1284.0051,
    y2: 1467.5753,
    gradientTransform: "matrix(0.9919 -0.127 0.127 0.9919 2520.1729 -696.4259)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000004547523380210874390000007617262184342191782_)"
    },
    d: "M1440.725,1075.014l-0.207-6.054 c0.448-1.509,1.629-2.688,3.145-3.132c5.669-1.662,19.813-5.117,27.384-0.837l1.922,6.819L1440.725,1075.014z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012462917206498772280000015513910628167089316_",
    gradientUnits: "userSpaceOnUse",
    x1: -1288.0582,
    y1: 1309.5554,
    x2: -1283.3914,
    y2: 1467.5607,
    gradientTransform: "matrix(0.9919 -0.127 0.127 0.9919 2520.1729 -696.4259)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000012462917206498772280000015513910628167089316_)"
    },
    d: "M1458.065,1066.945 c-1.29,0.496-2.625,0.665-4.005,0.508c-1.669-0.191-2.995-1.492-3.208-3.151l-2.649-20.705l9.533-1.22l2.648,20.692 C1460.597,1064.734,1459.64,1066.34,1458.065,1066.945z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052072380192928544360000001466906537339315091_",
    gradientUnits: "userSpaceOnUse",
    x1: -1321.7972,
    y1: 1551.5286,
    x2: -1331.0801,
    y2: 1619.6025,
    gradientTransform: "matrix(0.9919 -0.127 0.127 0.9919 2520.1729 -696.4259)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5304,
    style: {
      stopColor: "#FE7164"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7214,
    style: {
      stopColor: "#FE776B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8575,
    style: {
      stopColor: "#FE8076"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9668,
    style: {
      stopColor: "#FF8D87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052072380192928544360000001466906537339315091_)"
    },
    d: "M1355.744,1062.1l102.083-16.512 c2.327-0.376,4.095-2.316,4.203-4.661c0.151-3.281,0.031-8.149-1.344-13.035c-1.564-5.556-6.974-9.14-12.743-8.542 c-19.183,1.992-67.868,8.236-93.343,22.284c-2.694,1.486-4.489,4.18-4.829,7.227c-0.325,2.905-0.299,6.726,1.087,10.441 C1351.594,1061.277,1353.656,1062.438,1355.744,1062.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.69,
      fill: "#FFFFFF"
    },
    d: "M1353.23,1057.465c-0.417,0-0.793-0.286-0.891-0.709 c-0.038-0.164-0.923-4.051-0.383-7.972c0.423-3.075,2.468-5.765,5.336-7.02c5.517-2.416,16.105-6.677,25.044-8.077 c0.499-0.076,0.968,0.264,1.046,0.764c0.078,0.5-0.263,0.968-0.763,1.046c-8.734,1.368-19.157,5.565-24.593,7.945 c-2.288,1.002-3.919,3.145-4.256,5.592c-0.495,3.59,0.344,7.271,0.353,7.307c0.114,0.493-0.192,0.985-0.685,1.099 C1353.368,1057.457,1353.299,1057.465,1353.23,1057.465z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000068643231315698890070000008417120113717364608_",
    gradientUnits: "userSpaceOnUse",
    x1: 1424.5536,
    y1: 882.999,
    x2: 1418.554,
    y2: 1079.4891
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5304,
    style: {
      stopColor: "#FE7164"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7214,
    style: {
      stopColor: "#FE776B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8575,
    style: {
      stopColor: "#FE8076"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9668,
    style: {
      stopColor: "#FF8D87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000068643231315698890070000008417120113717364608_)"
    },
    d: "M1300.531,1090.585 c33.066-4.662,176.149-24.501,218.41-24.805c3.638-0.026,6.898,2.221,8.123,5.631c3.882,10.803,12.134,35.997,14.824,61.673 c0.366,3.494-1.813,6.761-5.169,7.852l-92.701,30.129l-33.746,4.318l-103.8-7.168c-3.659-0.252-6.676-2.938-7.323-6.531 c-2.306-12.796-7.201-42.885-6.208-62.783C1293.153,1094.672,1296.32,1091.179,1300.531,1090.585z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1410.031,1167.437c-0.008,0-0.016,0-0.024-0.001l-2.741-0.189 c-0.189-0.013-0.332-0.177-0.319-0.366c0.014-0.189,0.196-0.327,0.366-0.319l2.741,0.189c0.189,0.013,0.333,0.177,0.319,0.367 C1410.361,1167.298,1410.21,1167.437,1410.031,1167.437z M1412.834,1167.078c-0.17,0-0.318-0.126-0.34-0.3 c-0.024-0.188,0.109-0.36,0.297-0.385l2.726-0.348c0.186-0.025,0.36,0.109,0.384,0.297c0.024,0.188-0.109,0.36-0.297,0.384 l-2.725,0.349C1412.863,1167.077,1412.848,1167.078,1412.834,1167.078z M1400.893,1166.806c-0.008,0-0.016,0-0.024-0.001 l-2.741-0.189c-0.189-0.013-0.333-0.177-0.319-0.366c0.013-0.19,0.192-0.329,0.366-0.319l2.741,0.189 c0.189,0.013,0.333,0.177,0.319,0.367C1401.223,1166.667,1401.072,1166.806,1400.893,1166.806z M1391.756,1166.175 c-0.008,0-0.016,0-0.024-0.001l-2.741-0.189c-0.189-0.013-0.332-0.177-0.319-0.366c0.013-0.189,0.188-0.33,0.366-0.319 l2.741,0.189c0.189,0.013,0.332,0.177,0.319,0.366C1392.086,1166.036,1391.935,1166.175,1391.756,1166.175z M1421.919,1165.915 c-0.17,0-0.318-0.126-0.34-0.3c-0.024-0.188,0.109-0.36,0.297-0.384l2.726-0.349c0.187-0.025,0.36,0.109,0.384,0.297 c0.024,0.188-0.109,0.36-0.297,0.384l-2.726,0.349C1421.948,1165.914,1421.933,1165.915,1421.919,1165.915z M1382.618,1165.544 c-0.008,0-0.016,0-0.024-0.001l-2.741-0.189c-0.189-0.013-0.332-0.177-0.319-0.366c0.014-0.189,0.195-0.337,0.366-0.319 l2.741,0.189c0.189,0.013,0.333,0.177,0.319,0.366C1382.948,1165.405,1382.797,1165.544,1382.618,1165.544z M1373.481,1164.913 c-0.008,0-0.016,0-0.024-0.001l-2.741-0.189c-0.189-0.013-0.333-0.177-0.319-0.366c0.013-0.19,0.18-0.328,0.367-0.319 l2.741,0.19c0.189,0.013,0.332,0.177,0.319,0.366C1373.811,1164.774,1373.66,1164.913,1373.481,1164.913z M1431.004,1164.753 c-0.17,0-0.318-0.126-0.34-0.3c-0.024-0.188,0.109-0.36,0.297-0.385l2.725-0.349c0.188-0.022,0.36,0.109,0.384,0.297 c0.024,0.188-0.109,0.36-0.297,0.385l-2.726,0.349C1431.033,1164.752,1431.019,1164.753,1431.004,1164.753z M1364.344,1164.282 c-0.008,0-0.016,0-0.024-0.001l-2.741-0.189c-0.189-0.013-0.332-0.177-0.319-0.366c0.013-0.19,0.187-0.329,0.366-0.319 l2.741,0.189c0.189,0.013,0.333,0.177,0.319,0.366C1364.673,1164.143,1364.522,1164.282,1364.344,1164.282z M1355.206,1163.651 c-0.008,0-0.016,0-0.024-0.001l-2.741-0.189c-0.189-0.013-0.333-0.177-0.319-0.366c0.014-0.19,0.193-0.331,0.366-0.319 l2.741,0.19c0.189,0.013,0.333,0.177,0.319,0.366C1355.535,1163.512,1355.385,1163.651,1355.206,1163.651z M1440.089,1163.59 c-0.17,0-0.318-0.126-0.34-0.3c-0.024-0.188,0.109-0.36,0.297-0.384l2.114-0.271l0.524-0.177 c0.179-0.059,0.374,0.04,0.433,0.221c0.059,0.18-0.04,0.374-0.221,0.433l-0.587,0.191l-2.176,0.284 C1440.118,1163.589,1440.104,1163.59,1440.089,1163.59z M1346.069,1163.02c-0.008,0-0.016,0-0.024-0.001l-2.741-0.189 c-0.189-0.013-0.332-0.177-0.319-0.366c0.013-0.189,0.189-0.333,0.366-0.319l2.741,0.189c0.189,0.013,0.332,0.177,0.319,0.367 C1346.398,1162.881,1346.247,1163.02,1346.069,1163.02z M1336.931,1162.389c-0.008,0-0.016,0-0.024-0.001l-2.741-0.189 c-0.189-0.013-0.332-0.177-0.319-0.366c0.013-0.19,0.196-0.334,0.366-0.319l2.741,0.189c0.189,0.013,0.333,0.177,0.319,0.366 C1337.26,1162.25,1337.11,1162.389,1336.931,1162.389z M1327.793,1161.758c-0.008,0-0.016,0-0.024-0.001l-2.741-0.189 c-0.189-0.013-0.333-0.177-0.319-0.366c0.014-0.189,0.192-0.33,0.366-0.319l2.741,0.189c0.19,0.013,0.333,0.177,0.319,0.366 C1328.123,1161.619,1327.972,1161.758,1327.793,1161.758z M1448.887,1161.147c-0.145,0-0.279-0.092-0.327-0.237 c-0.059-0.181,0.04-0.374,0.221-0.433l2.613-0.849c0.18-0.059,0.374,0.04,0.433,0.22c0.059,0.181-0.04,0.374-0.221,0.433 l-2.613,0.849C1448.958,1161.142,1448.923,1161.147,1448.887,1161.147z M1318.656,1161.127c-0.008,0-0.016,0-0.024-0.001 l-2.741-0.189c-0.189-0.013-0.332-0.177-0.319-0.366c0.013-0.189,0.188-0.332,0.366-0.319l2.741,0.189 c0.189,0.013,0.333,0.177,0.319,0.366C1318.986,1160.988,1318.835,1161.127,1318.656,1161.127z M1309.518,1160.496 c-0.008,0-0.016,0-0.024-0.001l-2.554-0.176l-0.127-0.714c-0.033-0.187,0.092-0.365,0.279-0.398 c0.181-0.035,0.365,0.091,0.398,0.279l0.033,0.184l2.019,0.14c0.189,0.013,0.333,0.177,0.319,0.366 C1309.848,1160.357,1309.697,1160.496,1309.518,1160.496z M1457.598,1158.316c-0.145,0-0.279-0.092-0.327-0.237 c-0.059-0.18,0.04-0.374,0.221-0.433l2.613-0.849c0.18-0.059,0.374,0.04,0.433,0.22c0.059,0.181-0.04,0.374-0.221,0.433 l-2.613,0.849C1457.669,1158.311,1457.634,1158.316,1457.598,1158.316z M1466.309,1155.485c-0.145,0-0.279-0.092-0.327-0.237 c-0.059-0.18,0.04-0.374,0.221-0.433l2.613-0.849c0.18-0.059,0.374,0.04,0.433,0.22c0.059,0.18-0.04,0.374-0.221,0.433 l-2.613,0.849C1466.38,1155.48,1466.344,1155.485,1466.309,1155.485z M1306.061,1153.564c-0.165,0-0.311-0.119-0.338-0.287 c-0.145-0.871-0.292-1.778-0.443-2.716c-0.03-0.188,0.097-0.364,0.284-0.394c0.188-0.031,0.364,0.097,0.394,0.285 c0.151,0.937,0.299,1.842,0.443,2.713c0.031,0.187-0.096,0.364-0.283,0.395 C1306.098,1153.563,1306.079,1153.564,1306.061,1153.564z M1475.02,1152.654c-0.145,0-0.279-0.092-0.327-0.237 c-0.059-0.18,0.04-0.374,0.221-0.433l2.613-0.849c0.18-0.059,0.374,0.04,0.433,0.22c0.059,0.18-0.04,0.374-0.221,0.433 l-2.613,0.849C1475.091,1152.649,1475.055,1152.654,1475.02,1152.654z M1483.731,1149.823c-0.145,0-0.279-0.092-0.327-0.237 c-0.059-0.18,0.04-0.374,0.221-0.433l2.613-0.849c0.18-0.059,0.374,0.04,0.433,0.22c0.059,0.18-0.04,0.374-0.221,0.433 l-2.613,0.849C1483.802,1149.817,1483.766,1149.823,1483.731,1149.823z M1492.441,1146.991c-0.145,0-0.279-0.092-0.327-0.237 c-0.059-0.18,0.04-0.374,0.221-0.433l2.613-0.849c0.181-0.059,0.374,0.04,0.433,0.22c0.059,0.18-0.04,0.374-0.221,0.433 l-2.613,0.849C1492.512,1146.986,1492.476,1146.991,1492.441,1146.991z M1304.638,1144.508c-0.167,0-0.314-0.123-0.339-0.293 c-0.132-0.892-0.264-1.801-0.395-2.724c-0.027-0.188,0.103-0.362,0.292-0.389c0.187-0.025,0.362,0.104,0.388,0.292 c0.131,0.922,0.263,1.829,0.395,2.72c0.028,0.188-0.102,0.362-0.29,0.39 C1304.672,1144.507,1304.655,1144.508,1304.638,1144.508z M1501.152,1144.161c-0.145,0-0.279-0.092-0.327-0.237 c-0.059-0.18,0.04-0.374,0.221-0.433l2.613-0.849c0.181-0.059,0.374,0.04,0.433,0.22c0.059,0.18-0.04,0.374-0.221,0.433 l-2.613,0.849C1501.223,1144.155,1501.187,1144.161,1501.152,1144.161z M1509.863,1141.329c-0.145,0-0.279-0.092-0.327-0.237 c-0.059-0.18,0.04-0.374,0.221-0.433l2.613-0.849c0.179-0.059,0.374,0.04,0.433,0.22s-0.04,0.374-0.221,0.433l-2.613,0.849 C1509.933,1141.324,1509.898,1141.329,1509.863,1141.329z M1518.573,1138.498c-0.145,0-0.279-0.092-0.327-0.237 c-0.059-0.18,0.04-0.374,0.221-0.433l2.613-0.849c0.179-0.059,0.374,0.04,0.433,0.22c0.059,0.18-0.04,0.374-0.221,0.433 l-2.613,0.849C1518.644,1138.493,1518.609,1138.498,1518.573,1138.498z M1527.284,1135.667c-0.145,0-0.279-0.092-0.327-0.237 c-0.059-0.18,0.04-0.374,0.221-0.433l2.613-0.849c0.18-0.059,0.374,0.04,0.433,0.22c0.058,0.18-0.04,0.374-0.221,0.433 l-2.613,0.849C1527.355,1135.662,1527.32,1135.667,1527.284,1135.667z M1303.385,1135.428c-0.17,0-0.318-0.127-0.34-0.3 c-0.115-0.903-0.229-1.814-0.339-2.731c-0.023-0.188,0.111-0.359,0.299-0.382c0.191-0.023,0.36,0.112,0.382,0.3 c0.111,0.915,0.224,1.825,0.339,2.727c0.024,0.188-0.109,0.36-0.297,0.384 C1303.414,1135.427,1303.4,1135.428,1303.385,1135.428z M1533.319,1131.119c-0.171,0-0.319-0.127-0.34-0.301 c-0.112-0.908-0.23-1.815-0.356-2.72c-0.026-0.188,0.105-0.361,0.293-0.387c0.186-0.028,0.361,0.105,0.387,0.293 c0.125,0.909,0.245,1.819,0.357,2.73c0.023,0.189-0.111,0.36-0.299,0.383 C1533.347,1131.118,1533.333,1131.119,1533.319,1131.119z M1302.332,1126.325c-0.174,0-0.323-0.132-0.341-0.308 c-0.094-0.912-0.183-1.827-0.269-2.74c-0.018-0.189,0.121-0.356,0.31-0.374c0.191-0.019,0.356,0.121,0.374,0.31 c0.085,0.912,0.175,1.823,0.269,2.734c0.02,0.189-0.118,0.358-0.307,0.377 C1302.356,1126.324,1302.344,1126.325,1302.332,1126.325z M1531.983,1122.057c-0.164,0-0.31-0.118-0.338-0.286 c-0.154-0.903-0.313-1.802-0.477-2.698c-0.034-0.187,0.089-0.365,0.276-0.4c0.188-0.034,0.366,0.09,0.4,0.276 c0.164,0.898,0.324,1.8,0.478,2.706c0.032,0.187-0.094,0.365-0.281,0.396 C1532.022,1122.055,1532.002,1122.057,1531.983,1122.057z M1301.535,1117.194c-0.179,0-0.33-0.138-0.342-0.319 c-0.065-0.921-0.123-1.838-0.176-2.748c-0.011-0.189,0.133-0.352,0.323-0.363c0.186-0.007,0.352,0.134,0.363,0.323 c0.053,0.908,0.111,1.822,0.176,2.74c0.013,0.189-0.129,0.353-0.319,0.366 C1301.552,1117.194,1301.544,1117.194,1301.535,1117.194z M1530.265,1113.062c-0.159,0-0.301-0.111-0.335-0.273 c-0.19-0.901-0.384-1.796-0.581-2.683c-0.041-0.185,0.076-0.369,0.261-0.41c0.185-0.041,0.369,0.075,0.41,0.261 c0.197,0.89,0.392,1.787,0.582,2.69c0.039,0.186-0.08,0.368-0.265,0.407C1530.312,1113.06,1530.288,1113.062,1530.265,1113.062 z M1301.098,1108.04c-0.187,0-0.339-0.149-0.343-0.336c-0.021-0.932-0.033-1.851-0.036-2.755 c-0.001-0.19,0.152-0.344,0.342-0.345h0.001c0.189,0,0.343,0.153,0.343,0.342c0.003,0.9,0.015,1.815,0.036,2.743 c0.005,0.19-0.146,0.347-0.336,0.351C1301.103,1108.04,1301.1,1108.04,1301.098,1108.04z M1528.219,1104.131 c-0.154,0-0.294-0.105-0.333-0.261c-0.221-0.899-0.445-1.786-0.67-2.663c-0.047-0.184,0.063-0.371,0.247-0.418 c0.189-0.047,0.372,0.064,0.418,0.247c0.226,0.879,0.45,1.769,0.672,2.669c0.045,0.184-0.067,0.37-0.251,0.416 C1528.274,1104.127,1528.246,1104.131,1528.219,1104.131z M1301.681,1099.1c-0.167,0-0.326-0.115-0.354-0.281 c-0.032-0.183,0.069-0.354,0.25-0.392c0.008-0.002,0.052-0.01,0.06-0.01l2.685-0.378c0.188-0.028,0.361,0.104,0.388,0.292 c0.026,0.188-0.104,0.362-0.292,0.388l-2.687,0.378C1301.715,1099.099,1301.698,1099.1,1301.681,1099.1z M1310.723,1097.833 c-0.168,0-0.316-0.124-0.34-0.296c-0.026-0.188,0.105-0.361,0.293-0.387l2.723-0.379c0.19-0.027,0.362,0.105,0.388,0.293 s-0.105,0.361-0.293,0.387l-2.723,0.379C1310.755,1097.832,1310.739,1097.833,1310.723,1097.833z M1319.802,1096.574 c-0.169,0-0.316-0.125-0.34-0.297c-0.026-0.188,0.106-0.361,0.294-0.387l2.723-0.375c0.19-0.027,0.361,0.106,0.387,0.293 c0.026,0.188-0.105,0.361-0.293,0.387l-2.723,0.375C1319.833,1096.573,1319.817,1096.574,1319.802,1096.574z  M1328.879,1095.328c-0.169,0-0.316-0.125-0.34-0.297c-0.026-0.188,0.106-0.361,0.294-0.387l2.724-0.372 c0.183-0.026,0.361,0.106,0.387,0.294c0.025,0.188-0.106,0.361-0.294,0.387l-2.724,0.372 C1328.91,1095.327,1328.895,1095.328,1328.879,1095.328z M1525.885,1095.27c-0.15,0-0.289-0.099-0.331-0.251 c-0.251-0.898-0.501-1.779-0.751-2.642c-0.053-0.182,0.052-0.373,0.234-0.425c0.186-0.054,0.373,0.052,0.426,0.234 c0.25,0.865,0.501,1.747,0.753,2.648c0.051,0.183-0.056,0.372-0.239,0.423 C1525.947,1095.266,1525.915,1095.27,1525.885,1095.27z M1337.958,1094.092c-0.169,0-0.316-0.125-0.34-0.297 c-0.025-0.188,0.106-0.361,0.294-0.387l2.724-0.368c0.188-0.027,0.361,0.107,0.386,0.295c0.025,0.188-0.107,0.361-0.294,0.386 l-2.724,0.368C1337.989,1094.091,1337.973,1094.092,1337.958,1094.092z M1347.038,1092.869c-0.169,0-0.317-0.125-0.34-0.298 c-0.025-0.188,0.106-0.361,0.294-0.386l2.725-0.365c0.181-0.028,0.361,0.107,0.386,0.295c0.025,0.188-0.107,0.361-0.295,0.386 l-2.724,0.365C1347.069,1092.868,1347.053,1092.869,1347.038,1092.869z M1356.12,1091.656c-0.169,0-0.317-0.125-0.34-0.298 c-0.025-0.188,0.107-0.361,0.295-0.386l2.725-0.361c0.183-0.024,0.36,0.108,0.385,0.295c0.025,0.188-0.107,0.361-0.295,0.386 l-2.724,0.361C1356.15,1091.655,1356.135,1091.656,1356.12,1091.656z M1365.203,1090.457c-0.17,0-0.317-0.126-0.34-0.299 c-0.025-0.188,0.107-0.361,0.295-0.385l2.726-0.358c0.184-0.025,0.36,0.108,0.385,0.296c0.025,0.188-0.108,0.361-0.296,0.385 l-2.725,0.358C1365.234,1090.456,1365.219,1090.457,1365.203,1090.457z M1374.288,1089.27c-0.17,0-0.317-0.126-0.34-0.299 c-0.024-0.188,0.108-0.36,0.296-0.385l2.725-0.354c0.182-0.026,0.36,0.108,0.385,0.296c0.024,0.188-0.108,0.361-0.297,0.385 l-2.724,0.353C1374.318,1089.269,1374.303,1089.27,1374.288,1089.27z M1383.375,1088.097c-0.17,0-0.318-0.126-0.34-0.3 c-0.024-0.188,0.109-0.36,0.297-0.384l2.725-0.349c0.189-0.023,0.36,0.109,0.384,0.297c0.024,0.188-0.109,0.36-0.297,0.384 l-2.726,0.349C1383.405,1088.096,1383.39,1088.097,1383.375,1088.097z M1392.461,1086.939c-0.171,0-0.318-0.127-0.34-0.3 c-0.024-0.188,0.109-0.36,0.298-0.384l2.652-0.335c0.193-0.025,0.398,0.105,0.421,0.293c0.023,0.188-0.072,0.355-0.261,0.379 l-2.727,0.344C1392.49,1086.938,1392.475,1086.939,1392.461,1086.939z M1523.287,1086.481c-0.147,0-0.282-0.094-0.328-0.241 c-0.281-0.904-0.558-1.777-0.828-2.619c-0.058-0.181,0.042-0.374,0.222-0.432c0.18-0.058,0.374,0.042,0.432,0.222 c0.271,0.844,0.548,1.719,0.83,2.625c0.056,0.181-0.045,0.374-0.226,0.43 C1523.356,1086.476,1523.321,1086.481,1523.287,1086.481z M1401.549,1085.796c-0.171,0-0.319-0.127-0.34-0.301 c-0.023-0.188,0.11-0.36,0.298-0.383l2.727-0.339c0.194-0.023,0.36,0.11,0.383,0.299c0.023,0.188-0.11,0.36-0.298,0.383 l-2.727,0.339C1401.578,1085.795,1401.563,1085.796,1401.549,1085.796z M1410.639,1084.671c-0.171,0-0.319-0.128-0.34-0.302 c-0.023-0.188,0.111-0.36,0.299-0.383l2.728-0.334c0.189-0.021,0.36,0.111,0.382,0.3c0.023,0.188-0.111,0.359-0.299,0.382 l-2.727,0.334C1410.668,1084.671,1410.653,1084.671,1410.639,1084.671z M1419.732,1083.565c-0.171,0-0.319-0.128-0.34-0.302 c-0.023-0.188,0.111-0.359,0.3-0.382l2.728-0.328c0.192-0.022,0.36,0.112,0.382,0.3c0.023,0.188-0.112,0.359-0.3,0.382 l-2.729,0.328C1419.76,1083.564,1419.746,1083.565,1419.732,1083.565z M1428.828,1082.481c-0.172,0-0.32-0.129-0.341-0.303 c-0.022-0.188,0.113-0.359,0.301-0.381l2.729-0.321c0.194-0.023,0.359,0.113,0.381,0.301c0.022,0.188-0.113,0.359-0.301,0.381 l-2.729,0.321C1428.855,1082.48,1428.842,1082.481,1428.828,1082.481z M1437.926,1081.42c-0.172,0-0.321-0.129-0.341-0.304 c-0.021-0.188,0.114-0.359,0.302-0.381l2.73-0.313c0.18-0.022,0.359,0.114,0.38,0.302c0.021,0.188-0.114,0.359-0.302,0.38 l-2.73,0.313C1437.952,1081.419,1437.939,1081.42,1437.926,1081.42z M1447.027,1080.386c-0.172,0-0.321-0.13-0.341-0.305 c-0.021-0.188,0.115-0.359,0.303-0.38l2.731-0.304c0.188-0.02,0.358,0.115,0.379,0.303s-0.115,0.359-0.304,0.379l-2.73,0.304 C1447.053,1080.385,1447.04,1080.386,1447.027,1080.386z M1456.132,1079.384c-0.173,0-0.322-0.131-0.341-0.307 c-0.021-0.188,0.116-0.358,0.304-0.378l2.733-0.294c0.194-0.021,0.358,0.116,0.378,0.305c0.021,0.188-0.116,0.358-0.305,0.378 l-2.732,0.294C1456.157,1079.383,1456.144,1079.384,1456.132,1079.384z M1465.24,1078.419c-0.174,0-0.323-0.131-0.341-0.308 c-0.019-0.189,0.118-0.357,0.306-0.377l2.734-0.281c0.19-0.02,0.357,0.118,0.376,0.307c0.019,0.189-0.118,0.357-0.307,0.377 l-2.732,0.281C1465.264,1078.418,1465.252,1078.419,1465.24,1078.419z M1520.433,1077.771c-0.142,0-0.276-0.089-0.325-0.232 c-0.326-0.947-0.63-1.813-0.908-2.592c-0.063-0.179,0.03-0.375,0.208-0.439s0.375,0.03,0.439,0.208 c0.278,0.781,0.583,1.649,0.91,2.599c0.062,0.179-0.034,0.375-0.213,0.437 C1520.507,1077.765,1520.47,1077.771,1520.433,1077.771z M1474.354,1077.498c-0.174,0-0.324-0.133-0.341-0.31 c-0.019-0.189,0.12-0.357,0.308-0.375l2.736-0.266c0.19-0.02,0.356,0.12,0.375,0.309c0.018,0.189-0.12,0.357-0.309,0.375 l-2.734,0.266C1474.377,1077.498,1474.365,1077.498,1474.354,1077.498z M1483.473,1076.634c-0.175,0-0.325-0.134-0.342-0.312 c-0.017-0.189,0.122-0.356,0.311-0.373l2.738-0.246c0.183-0.018,0.355,0.122,0.372,0.312c0.017,0.189-0.123,0.356-0.312,0.372 l-2.736,0.246C1483.494,1076.634,1483.484,1076.634,1483.473,1076.634z M1492.599,1075.842c-0.177,0-0.327-0.136-0.342-0.316 c-0.016-0.189,0.125-0.355,0.315-0.37c0.93-0.076,1.843-0.149,2.74-0.22c0.191-0.013,0.354,0.126,0.369,0.316 c0.015,0.189-0.126,0.355-0.316,0.37c-0.896,0.07-1.808,0.143-2.738,0.219 C1492.618,1075.842,1492.609,1075.842,1492.599,1075.842z M1501.733,1075.151c-0.179,0-0.33-0.139-0.342-0.32 c-0.013-0.189,0.13-0.353,0.319-0.366c0.937-0.064,1.851-0.125,2.744-0.181c0.184-0.012,0.352,0.132,0.364,0.321 c0.012,0.189-0.132,0.353-0.321,0.365c-0.891,0.056-1.804,0.117-2.74,0.181 C1501.749,1075.151,1501.741,1075.151,1501.733,1075.151z M1510.877,1074.616c-0.182,0-0.334-0.144-0.343-0.328 c-0.009-0.189,0.138-0.35,0.327-0.359c0.952-0.044,1.868-0.083,2.749-0.115c0.205-0.01,0.349,0.142,0.356,0.331 c0.007,0.189-0.141,0.349-0.331,0.356c-0.879,0.032-1.793,0.07-2.742,0.115 C1510.888,1074.615,1510.882,1074.616,1510.877,1074.616z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100365472376743222200000011210887760730035335_",
    gradientUnits: "userSpaceOnUse",
    x1: -1313.921,
    y1: 1624.5898,
    x2: -1327.3311,
    y2: 1730.838,
    gradientTransform: "matrix(0.9919 -0.127 0.127 0.9919 2520.1729 -696.4259)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000100365472376743222200000011210887760730035335_)"
    },
    d: "M1442.654,1185.638l-29.564,3.783 c-3.874,0.496-7.506-1.969-8.455-5.739l-7.056-28.012c-1.124-4.462,1.921-8.904,6.506-9.491l35.516-4.545 c4.492-0.575,8.509,2.808,8.681,7.313l1.104,28.773C1449.539,1181.696,1446.618,1185.131,1442.654,1185.638z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088845818791914187280000001006706789599318965_",
    gradientUnits: "userSpaceOnUse",
    x1: -1342.6611,
    y1: 1707.9502,
    x2: -1303.6665,
    y2: 1707.9502,
    gradientTransform: "matrix(0.9919 -0.127 0.127 0.9919 2520.1729 -696.4259)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5304,
    style: {
      stopColor: "#FE7164"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7214,
    style: {
      stopColor: "#FE776B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8575,
    style: {
      stopColor: "#FE8076"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9668,
    style: {
      stopColor: "#FF8D87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088845818791914187280000001006706789599318965_)"
    },
    d: "M1438.348,1180.871l-22.501,2.879 c-2.949,0.377-5.713-1.499-6.436-4.368l-5.37-21.32c-0.855-3.396,1.462-6.777,4.953-7.223l27.032-3.459 c3.419-0.437,6.476,2.137,6.607,5.566l0.84,21.9C1443.588,1177.87,1441.365,1180.485,1438.348,1180.871z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139985866193641019060000013532348600858815924_",
    gradientUnits: "userSpaceOnUse",
    x1: 1042.9982,
    y1: 970.2735,
    x2: 967.4689,
    y2: 1115.5223,
    gradientTransform: "matrix(1 0 0 1 404.3718 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000139985866193641019060000013532348600858815924_)"
    },
    d: "M1420.764,954.165 c6.974,28.815,7.158,57.004,6.097,67.268c-0.4,3.87-3.51,6.891-7.391,7.163c-4.408,0.308-10.408,0.713-15.77,1.022 c-5.894,0.34-12.435-3.385-16.809-6.498c-2.233-1.589-5.122,0.885-3.875,3.326c2.149,4.204,5.881,7.516,9.586,10.33 c2.229,1.693,9.636,4.702,9.119,8.036c-0.163,1.052-0.797,1.968-1.479,2.785c-4.117,4.939-10.344,7.577-16.491,9.464 c-0.771,0.237-1.585,0.489-2.128,1.085c-0.153,3.975,12.074,8.391,15.23,9.438c4.728,1.569,9.742,2.234,14.707,1.711 c12.304-1.296,23.665-9.788,30.292-20.027c17.715-27.372,26.874-60.426,30.22-85.705 C1455.594,947.091,1430.715,951.267,1420.764,954.165z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019660300793071672580000008869269566398240925_",
    gradientUnits: "userSpaceOnUse",
    x1: 1507.074,
    y1: 250.8432,
    x2: 1459.0693,
    y2: 601.8781
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000019660300793071672580000008869269566398240925_)"
    },
    d: "M1472.072,966.167 c13.142-99.276-63.363-175.612-63.363-175.612l-45.519,53.066c34.558,43.076,50.986,82.548,58.49,113.55 C1431.632,954.273,1455.594,949.694,1472.072,966.167z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001626313201114341400000005400598950048375980_",
    gradientUnits: "userSpaceOnUse",
    x1: 1599.5785,
    y1: 998.2164,
    x2: 2896.6489,
    y2: 1628.1436
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001626313201114341400000005400598950048375980_)"
    },
    d: "M1420.594,956.685 c-1.27,0-2.425-0.864-2.738-2.156c-9.249-38.217-28.748-76.051-57.948-112.449c-0.975-1.214-0.781-2.99,0.433-3.964 c1.213-0.972,2.99-0.779,3.963,0.435c29.723,37.05,49.585,75.625,59.032,114.651c0.366,1.514-0.564,3.036-2.077,3.402 C1421.038,956.66,1420.815,956.685,1420.594,956.685z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132795677871835658190000001852731766493079684_",
    gradientUnits: "userSpaceOnUse",
    x1: 739.3221,
    y1: 1501.196,
    x2: 916.3132,
    y2: 1718.6849
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132795677871835658190000001852731766493079684_)"
    },
    d: "M804.118,1545.218 c0.008-0.484-0.025-0.974-0.149-1.468c-7.321-29.024-43.656-47.101-43.656-47.101l-14.398,1.129 c-8.279,25.581-7.214,41.27-5.885,48.258c0.037,0.196,0.097,0.382,0.148,0.571 C752.056,1547.668,776.502,1548.361,804.118,1545.218z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120539335936992353980000009612144684921449355_",
    gradientUnits: "userSpaceOnUse",
    x1: -792.6332,
    y1: 1445.3944,
    x2: -1029.0996,
    y2: 1631.0685,
    gradientTransform: "matrix(1 0 0 1 1694.4741 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120539335936992353980000009612144684921449355_)"
    },
    d: "M740.178,1546.606 c0.641,2.334,2.364,4.151,4.569,4.614c16.896,3.553,43.749,0.694,55.024-0.78c2.488-0.325,4.306-2.626,4.347-5.223 C776.502,1548.361,752.056,1547.668,740.178,1546.606z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121242916677846889190000005253531805760119687_",
    gradientUnits: "userSpaceOnUse",
    x1: -937.2781,
    y1: 1448.0764,
    x2: -949.6938,
    y2: 1556.433,
    gradientTransform: "matrix(1 0 0 1 1694.4741 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121242916677846889190000005253531805760119687_)"
    },
    d: "M740.126,1476.332l6.098,29.356 c0.447,2.151,2.1,3.762,4.102,3.95c2.451,0.23,5.939,0.365,9.448-0.15c3.146-0.462,5.337-3.659,4.779-7.09l-4.239-26.066 H740.126z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016044847702608480830000005208717610339138195_",
    gradientUnits: "userSpaceOnUse",
    x1: -750.6263,
    y1: 1498.8156,
    x2: -987.0931,
    y2: 1684.4899,
    gradientTransform: "matrix(1 0 0 1 1694.4741 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016044847702608480830000005208717610339138195_)"
    },
    d: "M866.475,1546.235 c-15.902-0.445-24.127-2.318-28.379-4.056c-0.01,1.581-0.001,3.19,0.051,4.857c0.055,1.781,1.374,3.203,2.996,3.193 l87.311-0.564c2.786-0.018,4.414-3.249,3.207-5.805C920.213,1544.807,891.056,1546.923,866.475,1546.235z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000099624681892532011860000008111352713818955925_",
    gradientUnits: "userSpaceOnUse",
    x1: 845.2452,
    y1: 1493.8521,
    x2: 1043.2351,
    y2: 1738.3396
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000099624681892532011860000008111352713818955925_)"
    },
    d: "M931.66,1543.861 c-0.105-0.222-0.196-0.449-0.346-0.658c-7.711-10.774-27.349-32.228-66.156-41.533l-18.616-0.587c0,0-8.29,14.408-8.446,41.097 c4.252,1.738,12.477,3.611,28.379,4.056C891.056,1546.923,920.213,1544.807,931.66,1543.861z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109021295413151846920000008606278228505211829_",
    gradientUnits: "userSpaceOnUse",
    x1: -693.554,
    y1: 1393.8507,
    x2: -705.97,
    y2: 1502.209,
    gradientTransform: "matrix(0.998 -0.0629 0.0629 0.998 1461.1316 24.8335)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109021295413151846920000008606278228505211829_)"
    },
    d: "M842.261,1473.734 c0.294,1.372,4.167,22.26,5.668,30.359c0.357,1.924,1.856,3.337,3.64,3.436c3.188,0.179,8.329,0.2,12.75-1.001 c2.385-0.648,3.988-3.079,3.817-5.778l-2.083-33.04L842.261,1473.734z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147219605278642157320000001633626547741220501_",
    gradientUnits: "userSpaceOnUse",
    x1: 750.282,
    y1: 1360.4543,
    x2: 490.2822,
    y2: 1896.4551
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147219605278642157320000001633626547741220501_)"
    },
    d: "M828.154,1088.052 c0,0,25.609,175.974,44.09,385.381c0.344,3.9-2.764,7.294-6.594,8.101c-5.646,1.189-13.945,2.601-20.815,2.408 c-3.668-0.102-6.733-2.823-7.35-6.439c-6.296-36.922-51.222-235.076-63.013-278.688c0,0-13.544,185.252-9.215,281.363 c0.108,2.39-1.642,4.463-4.018,4.738c-3.605,0.417-9.372,0.733-16.711-0.047c-2.786-0.296-5.033-2.402-5.431-5.175 c-4.485-31.248-30.297-217.246-29.199-351.233c0.062-7.556,8.865-69.637,8.865-69.637L828.154,1088.052z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026852574139051293010000016559302229867570308_",
    gradientUnits: "userSpaceOnUse",
    x1: 848.9928,
    y1: 835.1616,
    x2: 490.6102,
    y2: 1596.036
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5304,
    style: {
      stopColor: "#FE7164"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7214,
    style: {
      stopColor: "#FE776B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8575,
    style: {
      stopColor: "#FE8076"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9668,
    style: {
      stopColor: "#FF8D87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026852574139051293010000016559302229867570308_)"
    },
    d: "M714.913,1098.195 c-2.633-0.936-4.469-3.323-4.755-6.102c-3.405-33.04-19.894-237.899,84.205-322.17c0,0,5.97-15.62,55.04,22.775 c49.07,38.394,22.798,78.638,11.05,134.146c-14.216,67.169-39.159,122.074-28.123,163.408c0.762,2.852-0.738,5.848-3.508,6.869 C790.703,1111.169,752.732,1111.634,714.913,1098.195z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027584738289413496550000004561670007509706141_",
    gradientUnits: "userSpaceOnUse",
    x1: 859.4923,
    y1: 663.8605,
    x2: 797.9955,
    y2: 849.851
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027584738289413496550000004561670007509706141_)"
    },
    d: "M834.969,708.542 c-0.033,2.915-41.601,61.957-41.601,61.957s7.461,14.695,43.081,26.625l30.747-63.217L834.969,708.542z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135686784017968983270000007709037847649892756_",
    gradientUnits: "userSpaceOnUse",
    x1: 524.7422,
    y1: 711.1342,
    x2: 388.9921,
    y2: 724.4982,
    gradientTransform: "matrix(1 0 0 1 404.3718 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000135686784017968983270000007709037847649892756_)"
    },
    d: "M867.697,674.709 c0,0,14.791,33.977,15.784,51.81c0.993,17.833,4.836,29.405-15.784,32.996c-20.62,3.591-37.99-6.681-47.401-24.445 c0,0-14.745-27.372-11.437-38.582C812.167,685.279,867.697,674.709,867.697,674.709z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141431418934496600910000002894953803688591253_",
    gradientUnits: "userSpaceOnUse",
    x1: 377.2415,
    y1: 621.743,
    x2: 448.5364,
    y2: 705.246,
    gradientTransform: "matrix(1 0 0 1 404.3718 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000141431418934496600910000002894953803688591253_)"
    },
    d: "M827.342,722.298l1.174-0.517 c1.494-0.659,2.134-2.438,1.383-3.888c-2.907-5.618-8.576-18.492-1.253-21.496c9.437-3.87,46.819-11.494,54.885-24.758 c7.752-12.748,0.883-29.204-9.439-33.884c-0.691-0.313-1.505-0.065-1.859,0.606l-0.86,1.628 c-0.589,1.114-2.235,0.945-2.585-0.265l0,0c-0.336-1.162-1.882-1.387-2.523-0.362c-2.479,3.969-9.172,10.402-27.071,13.705 c-25.439,4.695-42.257,14.989-42.675,32.568c-0.026,1.116-1.215,1.737-2.169,1.156c-1.878-1.145-4.884-1.682-8.901,1.696 c-6.986,5.874-4.127,21.112,11.188,33.647c0.728,0.595,0.722,1.731-0.066,2.244c-2.776,1.807-6.915,6.108,3.809,11.84 c11.093,5.93,19.376,5.443,22.565,4.917c0.794-0.131,1.305-0.899,1.132-1.685l-3.404-15.45 c-0.193-0.875,0.473-1.703,1.368-1.703H827.342z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166658317224641660030000013888427001682480527_",
    gradientUnits: "userSpaceOnUse",
    x1: 524.7571,
    y1: 711.2844,
    x2: 389.0072,
    y2: 724.6483,
    gradientTransform: "matrix(1 0 0 1 404.3718 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000166658317224641660030000013888427001682480527_)"
    },
    d: "M827.983,725.558 c0,0-5.643-21.704-15.373-15.619c-9.731,6.085,5.05,24.318,12.873,25.13L827.983,725.558z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182515873322560145390000000757703049231242141_",
    gradientUnits: "userSpaceOnUse",
    x1: 411.8568,
    y1: 915.5976,
    x2: 351.2886,
    y2: 977.4019,
    gradientTransform: "matrix(1 0 0 1 404.3718 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182515873322560145390000000757703049231242141_)"
    },
    d: "M865.188,810.514l2.866,76.972 c8.14,2.801,15.89,4.98,23.27,6.607c4.616-14.862,14.781-33.102,23.104-46.664 C883.848,836.619,865.188,810.514,865.188,810.514z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167377321434490677380000003075866450886341291_",
    gradientUnits: "userSpaceOnUse",
    x1: 668.8734,
    y1: 802.7374,
    x2: 487.4773,
    y2: 892.9719,
    gradientTransform: "matrix(1 0 0 1 404.3718 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000167377321434490677380000003075866450886341291_)"
    },
    d: "M1017.864,809.205 c-41.949,45.291-75.902,47.957-103.436,38.224c-8.323,13.562-18.488,31.803-23.104,46.664 c112.023,24.697,138.402-78.287,138.402-78.287L1017.864,809.205z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039109477758594519560000006973956312713706906_",
    gradientUnits: "userSpaceOnUse",
    x1: 666.2178,
    y1: 780.1061,
    x2: 604.171,
    y2: 844.9108,
    gradientTransform: "matrix(1 0 0 1 404.3718 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039109477758594519560000006973956312713706906_)"
    },
    d: "M1026.372,804.394 c0,0,4.832-5.189,13.775-3.558c8.943,1.631,16.904,4.738,22.476,0c5.572-4.738,7.531,1.621,7.531,1.621l-16.686,12.684 L1026.372,804.394z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146482871613627858260000016797491297740952220_",
    gradientUnits: "userSpaceOnUse",
    x1: 669.7356,
    y1: 801.6679,
    x2: 488.34,
    y2: 891.9022,
    gradientTransform: "matrix(1 0 0 1 404.3718 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000146482871613627858260000016797491297740952220_)"
    },
    d: "M1016.392,813.265 c0,0,3.311-13.845,13.289-11.947s32.63,14.216,38.468,11.947c5.838-2.269,13.302-7.701,17.132-5.781l-6.746,8.387 c0,0,17.342-10.004,20.327-3.858l-28.856,16.239C1070.006,828.252,1027.788,824.025,1016.392,813.265z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137835440159195327340000003891372038685771160_",
    gradientUnits: "userSpaceOnUse",
    x1: 745.5385,
    y1: 954.7711,
    x2: 219.1116,
    y2: 859.5786,
    gradientTransform: "matrix(1 0 0 1 404.3718 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137835440159195327340000003891372038685771160_)"
    },
    d: "M818.622,911.255 c0,0,78.865,66.05,164.027,37.23c5.282-1.788,11.057-1.399,15.988,1.205l24.483,12.931c10.276,5.427,23.003,1.864,28.966-8.11 c3.401-5.69,6.304-12.188,6.881-18.414l-47.907-19.394l3.532-5.874c0,0-23.39-1.982-29.512,14.782 c0,0-44.552,18.531-119.685-64.11C865.396,861.498,831.302,890.489,818.622,911.255z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026865523559737543210000008968475667503858308_",
    gradientUnits: "userSpaceOnUse",
    x1: 375.2135,
    y1: 889.9141,
    x2: 209.3265,
    y2: 1045.7092,
    gradientTransform: "matrix(1 0 0 1 404.3718 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026865523559737543210000008968475667503858308_)"
    },
    d: "M814.377,910.571 c-0.26,0-0.523-0.074-0.754-0.232c-33.207-22.436-48.828-58.649-48.983-59.013c-0.29-0.688,0.03-1.479,0.716-1.769 c0.688-0.293,1.478,0.027,1.771,0.715c0.151,0.356,15.482,35.854,48.008,57.832c0.618,0.417,0.78,1.255,0.362,1.875 C815.236,910.363,814.81,910.571,814.377,910.571z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044152671104319108390000016555221749828308875_",
    gradientUnits: "userSpaceOnUse",
    x1: 374.1153,
    y1: 865.5883,
    x2: 208.2283,
    y2: 1021.3835,
    gradientTransform: "matrix(1 0 0 1 404.3718 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044152671104319108390000016555221749828308875_)"
    },
    d: "M863.84,860.378 c-0.443,0-0.878-0.219-1.136-0.62c-0.101-0.155-10.245-15.947-29.568-50.546c-5.942-10.639-13.751-17.376-23.21-20.024 c-15.665-4.377-30.761,4.022-30.911,4.106c-0.65,0.359-1.471,0.143-1.84-0.506c-0.368-0.649-0.142-1.472,0.506-1.841 c0.651-0.369,16.179-9.057,32.947-4.364c10.189,2.842,18.555,10.012,24.865,21.31c19.274,34.513,29.38,50.248,29.48,50.404 c0.404,0.625,0.223,1.461-0.403,1.865C864.343,860.309,864.09,860.378,863.84,860.378z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073711579130530237710000006475593234103104151_",
    gradientUnits: "userSpaceOnUse",
    x1: 1053.2361,
    y1: 1321.3002,
    x2: 1224.9602,
    y2: 1321.3002
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000073711579130530237710000006475593234103104151_)"
    },
    d: "M1097.771,1409.418 c-2.909,0-5.848-1.399-8.97-4.268c-12.131-11.144-14.987-28.533-15.707-44.85c-5.811,6.542-11.775,12.899-17.671,19.181 l-2.188-2.053c6.59-7.023,13.269-14.139,19.711-21.497c-0.542-21.971,0.467-44.179,2.997-66.01 c1.542-13.308,3.764-27.391,9.521-40.212c1.817-4.046,4.827-9.841,9.973-13.439c5.295-3.703,12.22-4.121,16.842-1.015 c5.218,3.507,6.635,10.238,7.247,14.997c3.664,28.496-7.467,54.635-17.449,71.544c-7.463,12.642-16.512,24.216-26.099,35.226 c0.482,16.575,2.744,34.793,14.853,45.918c2.63,2.417,4.98,3.553,7.16,3.473c3.617-0.131,6.452-3.51,8.749-6.799 c10.093-14.455,17.942-30.134,23.424-46.76c0.626-4.937,2.003-9.777,4.103-14.297l2.818,0.986 c-1.148,4.726-2.476,9.386-3.981,13.976c-0.575,4.772-0.404,9.634,0.542,14.354c0.513,2.559,2.682,11.004,9.061,12.219 c4.808,0.917,9.548-2.466,14.928-10.644l19.257-29.272l-1.898,8.175c-0.978,4.212-2.594,14.28,3.507,16.79 c3.499,1.438,7.197-0.645,11.114-2.851c3.837-2.161,7.803-4.398,12.213-3.81l1.545,0.205l-0.265,1.537 c-1.007,5.835-0.513,13.019,4.19,14.059c3.081,0.681,5.612-1.662,8.545-4.374c2.502-2.312,5.087-4.703,8.413-5.509l0.706,2.916 c-2.567,0.621-4.863,2.744-7.083,4.796c-3.254,3.009-6.625,6.12-11.229,5.1c-6.255-1.383-7.603-8.786-6.748-15.81 c-2.896,0.169-5.785,1.796-8.816,3.503c-4.368,2.46-8.885,5.003-13.728,3.011c-4.442-1.828-6.611-6.591-6.285-13.437 l-10.934,16.619c-3.857,5.863-9.922,13.48-17.996,11.941c-5.546-1.057-9.824-6.506-11.441-14.577 c-0.395-1.969-0.663-3.962-0.806-5.963c-5.293,13.688-12.216,26.686-20.697,38.833c-2.72,3.895-6.166,7.901-11.1,8.079 C1097.99,1409.416,1097.88,1409.418,1097.771,1409.418z M1105.04,1236.165c-2.643,0-5.458,0.868-7.884,2.565 c-4.537,3.172-7.284,8.487-8.955,12.209c-5.59,12.45-7.762,26.259-9.276,39.328c-2.387,20.597-3.411,41.531-3.048,62.281 c8.682-10.145,16.831-20.782,23.617-32.276c9.743-16.505,20.611-41.985,17.057-69.637c-0.854-6.642-2.743-10.738-5.945-12.89 C1109.028,1236.686,1107.085,1236.165,1105.04,1236.165z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesAddon);
export default __webpack_public_path__ + "static/media/sales_addon.e859dc6ee2eeaffd3b9da0a8673c1640.svg";
export { ForwardRef as ReactComponent };